import React, { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  es: {
    appName: "Ikas-Txiki Manager",
    appTagline: "Gestión de fútbol base, clara y sencilla",
    loginTitle: "Bienvenido de nuevo",
    loginSubtitle: "Accede al espacio de gestión de tu club",
    username: "Usuario",
    password: "Contraseña",
    usernamePlaceholder: "Nombre de usuario",
    loginButton: "Acceder al panel",
    loggingIn: "Comprobando acceso…",
    loginRequired: "Introduce usuario y contraseña.",
    loginInvalid: "Usuario o contraseña incorrectos.",
    loginNetworkError: "No se ha podido conectar. Revisa tu conexión e inténtalo de nuevo.",
    playerDialogDescription: "Formulario para revisar y editar la información permitida del jugador.",
    loginTooMany: "Demasiados intentos. Espera unos minutos antes de volver a intentarlo.",
    capsLockOn: "El bloqueo de mayúsculas está activado.",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    secureAccess: "Acceso privado y seguro",
    loginFeaturePlayers: "Jugadores y familias",
    loginFeatureSchedule: "Partidos y entrenamientos",
    loginFeatureAdmin: "Pagos y documentación",
    navStart: "Inicio",
    navPeople: "Personas",
    navSport: "Actividad deportiva",
    navManagement: "Administración",
    navSystem: "Sistema",
    openMenu: "Abrir navegación",
    closeMenu: "Cerrar navegación",
    mainNavigation: "Navegación principal",
    skipToContent: "Saltar al contenido",
    logout: "Cerrar sesión",
    viewGoogleMaps: "Ver en Google Maps",
    getDirections: "Cómo llegar",
    mapsPreviewHint: "Vista previa de la ubicación; no se guarda hasta guardar el formulario.",
    role_admin: "Administrador",
    role_admin_secondary: "Administrador del sistema 2",
    role_coordinator: "Coordinador",
    role_coach: "Entrenador",
    role_family: "Familia",
    role_player: "Jugador",
    usersAndPermissions: "Usuarios y permisos",
    usersIntro: "Gestiona el acceso y el ámbito de datos de cada persona.",
    userViews: "Vistas de cuentas",
    activeAndPendingUsers: "Activas y pendientes",
    archivedUsers: "Archivadas",
    createFamilyAccesses: "Crear accesos de familia",
    familyAccessesTitle: "Accesos familiares", familyAccessesDescription: "Información sincronizada desde Usuarios y permisos. Los accesos se crean únicamente allí.",
    familyParentLabel: "Progenitor/a", familyConfirmEmail: "He confirmado este correo", familyGrantAccess: "Dar acceso a la aplicación", familyInvitationFutureOnly: "Solo prepara futuras altas; no modifica cuentas existentes.",
    familyInvitationSend: "Enviar invitación", familyInvitationResend: "Reenviar invitación", familyInvitationNew: "Enviar nueva invitación",
    familyInvitationConfirmTitle: "Confirmar envío de invitación", familyInvitationConfirmResendTitle: "Confirmar reenvío de invitación", familyInvitationConfirmDescription: "Se enviará un correo para activar esta cuenta y crear una contraseña.", familyInvitationConfirmResendDescription: "Se enviará un nuevo enlace de activación y el anterior quedará sustituido.", familyInvitationRecipient: "Destinatario:",
    familyInvitationSaveFirst: "Guarda la ficha antes de enviar la invitación.", familyInvitationSaveAndContinue: "Guardar ficha para enviar", familyInvitationConfirmAndSave: "Confirmar correo y guardar", familyInvitationSavedContinue: "Ficha guardada. Ya puedes enviar la invitación.", familyInvitationEnableFirst: "Marca el acceso y guarda la ficha para poder enviar.", familyInvitationMissingEmail: "Añade un correo válido para poder enviar.", familyInvitationInvalidEmail: "El correo no es válido.", familyInvitationDuplicateEmail: "El correo está repetido en la familia.", familyInvitationUnconfirmedEmail: "Confirma el correo en la ficha antes de enviar.", familyInvitationUnavailable: "Este acceso no admite invitaciones.", familyInvitationManagedInUsers: "Esta cuenta se gestiona desde Usuarios y permisos → Seguridad.",
    familyInvitationSentPending: "Invitación enviada. La cuenta seguirá pendiente hasta que la familia cree su contraseña.", familyInvitationDeliveryPrefix: "Correo", familyInvitationDeliveryPending: "pendiente", familyInvitationDeliveryFailed: "fallido", familyInvitationDeliveryUnknown: "estado no confirmado", familyInvitationUnknownReason: "motivo no disponible", familyInvitationSent: "Invitación enviada correctamente.", familyInvitationNotSent: "La invitación no se ha enviado.",
    noName: "Sin nombre", noEmail: "Sin correo electrónico", viewAccount: "Ver cuenta",
    usersPermissionsGuideTitle: "¿Cómo gestionar usuarios y permisos?",
    usersPermissionsGuideAccount: "Cada persona tiene una cuenta propia: usuario, correo y contraseña.",
    usersPermissionsGuideSecrets: "No se muestran contraseñas, tokens ni enlaces de activación.",
    usersPermissionsGuideStatuses: "El estado puede ser Activa, Pendiente de activación o Bloqueada.",
    usersPermissionsGuidePending: "Una cuenta Pendiente de activación necesita completar la invitación y crear su contraseña.",
    usersPermissionsGuideManagement: "Desde esta pantalla se puede revisar el usuario, correo, rol, estado y último acceso; también bloquear, editar o restablecer el acceso mediante el flujo seguro ya existente.",
    usersPermissionsGuideFamilies: "Para progenitores, la creación y decisión de acceso se realiza preferentemente desde la ficha de Familia, en “Aprovisionamiento familiar”. Usuarios y permisos sirve para revisar y administrar las cuentas ya creadas.",
    usersPermissionsGuideDistinctEmails: "Dos progenitores que necesiten entrar por separado deben tener dos correos distintos.",
    usersPermissionsGuidePlayerEmail: "Cambiar el correo de un jugador no crea una cuenta ni envía una invitación.",
    usersPermissionsGuideFlowLabel: "Pasos para gestionar usuarios y permisos",
    usersPermissionsGuideStepOne: "Crear o revisar la persona.",
    usersPermissionsGuideStepTwo: "Asignar el rol y el ámbito correcto.",
    usersPermissionsGuideStepThree: "Revisar usuario, correo y estado.",
    usersPermissionsGuideStepFour: "Enviar o reenviar la invitación solo cuando corresponda.",
    usersPermissionsGuideSafetyNotice: "No compartas cuentas ni contraseñas; cada persona debe usar sus propias credenciales.",
    users: "Usuarios",
    userDialogDescription: "Crea o actualiza una cuenta persistente y su ámbito autorizado.",
    effectivePermissionsDescription: "Consulta las funciones permitidas por el rol y los datos incluidos en su ámbito.",
    security: "Seguridad", accessSecurity: "Seguridad de acceso",
    accessSecurityDescription: "Gestiona accesos sensibles. Cada acción requiere confirmación y queda auditada.",
    securityStatus: "Estado de seguridad", temporarilyLocked: "Bloqueada temporalmente",
    accessStatus: "Estado de acceso", currentStatus: "Estado actual", lastActivation: "Última activación",
    accessState_active: "Activa", accessState_pending_activation: "Pendiente de activación", accessState_blocked: "Bloqueada",
    accessAvailable: "Acceso disponible", invitation: "Invitación",
    invitationStatus_none: "Sin invitación", invitationStatus_pending: "Pendiente",
    invitationStatus_active: "Utilizada", invitationStatus_expired: "Caducada",
    invitationStatus_cancelled: "Cancelada", shownOnlyOnce: "Se mostrará una sola vez. Guárdalo ahora.",
    understoodHideSecret: "Entendido, ocultar", systemSecurityReadOnly: "La seguridad de esta cuenta se configura únicamente en el servidor.",
    generateTemporaryPassword: "Generar contraseña temporal", generateInvitation: "Enviar invitación por correo",
    closeSessions: "Cerrar sesiones", lockAccess: "Bloquear acceso", unlockAccess: "Desbloquear acceso",
    deactivateAccess: "Dar de baja acceso", confirmDeactivateAccess: "Se desactivará este acceso, se cerrarán sus sesiones y no se borrará ninguna ficha. ¿Quieres continuar?", accessDeactivated: "Acceso dado de baja correctamente",
    permanentDeleteUser: "Eliminar usuario definitivamente", permanentDeletionChecking: "Comprobando si MongoDB permite una eliminación atómica…",
    confirmSensitiveAction: "Esta acción afectará al acceso del usuario. ¿Quieres continuar?",
    securityActionCompleted: "Acción de seguridad completada", changePassword: "Cambiar contraseña",
    passwordChangedLoginAgain: "Contraseña actualizada. Inicia sesión de nuevo.",
    communicationDialogDescription: "Prepara una comunicación y revisa sus destinatarios antes de guardarla.",
    resetPassword: "Restablecer contraseña", passwordResetRequested: "Si la cuenta puede recuperarse, recibirá instrucciones por correo.",
    passwordHidden: "Contraseña oculta", emailAddress: "Correo electrónico", roleAndAccess: "Rol y estado de acceso", accountStatusLabel: "Estado de cuenta",
    noUsers: "Todavía no hay usuarios configurados.",
    noUsersFiltered: "No hay cuentas que coincidan con los filtros.",
    newUser: "Nuevo usuario",
    createUser: "Crear usuario",
    editUser: "Editar usuario",
    userSaved: "Usuario guardado correctamente",
    saveError: "No se han podido guardar los cambios.",
    role: "Rol",
    assignedTeams: "Equipos asignados",
    assignedCategories: "Categorías asignadas",
    linkedPlayer: "Jugador asociado",
    linkedFamily: "Familia asociada",
    familyContactSlot: "Progenitor titular",
    familyParentOne: "Progenitor 1",
    familyAccountScopeHint: "La cuenta se creará con este progenitor como titular y con todos sus hijos como jugadores asociados.",
    language: "Idioma",
    active: "Activo",
    inactive: "Inactivo",
    accountCounters: "Resumen de cuentas",
    pagination: "Paginación de usuarios",
    total: "Totales",
    pendingActivation: "Pendientes",
    suspended: "Suspendidas",
    blocked: "Bloqueadas",
    deactivated: "Desactivadas",
    incompleteLink: "Sin vinculación completa",
    accountStatus_active: "Activa",
    accountStatus_pending_activation: "Pendiente de activación",
    accountStatus_suspended: "Suspendida",
    accountStatus_deactivated: "Desactivada",
    accountStatus_incomplete_link: "Vinculación incompleta",
    searchUsers: "Buscar por nombre, correo o usuario",
    firstName: "Nombre",
    lastName: "Apellidos",
    confirmPassword: "Confirmar contraseña",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    passwordMismatch: "Las contraseñas no coinciden.",
    password_length: "12 caracteres como mínimo",
    password_upper: "Una letra mayúscula",
    password_lower: "Una letra minúscula",
    password_number: "Un número",
    password_symbol: "Un símbolo",
    systemAdministrator: "Administrador del sistema",
    configuredOnServer: "Configurado en el servidor",
    lastAccess: "Último acceso",
    never: "Nunca",
    effectivePermissions: "Permisos efectivos",
    viewProfile: "Ver ficha", userProfile: "Ficha administrativa", userProfileDescription: "Consulta identidad, permisos, vinculaciones, actividad y accesos sin exponer secretos.",
    identityAndAccess: "Datos y acceso", roleAndScope: "Rol y ámbito", recentActivity: "Actividad reciente", sessions: "Sesiones",
    individualSessionsUnavailable: "No existe seguimiento individual; solo está disponible cerrar todas las sesiones.", notAvailable: "No disponible", available: "Disponible",
    linkComplete: "Vinculación completa", securityState_verified: "Verificada", securityState_locked: "Bloqueada", securityState_password_change_required: "Cambio de contraseña pendiente", securityState_invitation_pending: "Invitación pendiente", securityState_invitation_expired: "Invitación caducada",
    wizardProgress: "Pasos para crear usuario", userStep_1: "Identidad", userStep_2: "Rol", userStep_3: "Ámbito", userStep_4: "Acceso",
    phone: "Teléfono", suggest: "Sugerir", searchTeams: "Buscar equipos", season: "Temporada", selectVisible: "Seleccionar visibles", clearSelection: "Quitar selección", selectedTeams: "Equipos seleccionados", summary: "Resumen",
    incompleteLinkWarning: "Falta completar la vinculación requerida. Una cuenta activa no puede guardarse así.", accessMethod: "Método de acceso", accessPassword: "Contraseña definitiva", accessTemporary: "Contraseña temporal", accessInvitation: "Generar invitación (sin enviar)", accessPending: "Dejar pendiente",
    roleHelp_admin: "Acceso administrativo completo al club.", roleHelp_coordinator: "Gestiona únicamente categorías y equipos asignados.", roleHelp_coach: "Gestiona exclusivamente sus equipos.", roleHelp_family: "Consulta únicamente sus hijos vinculados.", roleHelp_player: "Consulta únicamente su ficha personal.",
    chooseUserType: "Selecciona qué tipo de usuario quieres crear", userType: "Tipo de usuario",
    bulkFamilyTitle: "Crear accesos para familias", bulkPlayerTitle: "Crear accesos para jugadores de categoría superior",
    familyProvisioningGuideTitle: "¿Cómo funciona?", familyProvisioningManualTitle: "Modo manual", familyProvisioningManualDescription: "La persona administradora crea o envía cada acceso cuando decide hacerlo.", familyProvisioningDeliveryTitle: "Entrega técnica desactivada", familyProvisioningDeliveryDescription: "No se enviará ningún correo accidentalmente.", familyProvisioningAutomaticTitle: "Activar automático", familyProvisioningAutomaticDescription: "Permite preparar accesos al detectar dos progenitores con correos distintos y válidos. No lo actives hasta completar pruebas con varias familias.", familyProvisioningPreflightTitle: "Crear preflight", familyProvisioningPreflightDescription: "Revisa las familias y muestra casos preparados, correos repetidos, correos ausentes y accesos existentes. No crea cuentas, no modifica datos y no envía correos.", familyProvisioningFlowLabel: "Pasos recomendados para el aprovisionamiento familiar", familyProvisioningStepOne: "Ejecutar preflight.", familyProvisioningStepTwo: "Revisar y corregir correos.", familyProvisioningStepThree: "Probar con 2 o 3 familias.", familyProvisioningStepFour: "Activar el modo automático solo después de validar las pruebas.", familyProvisioningSafetyNotice: "Cada progenitor necesita un correo propio para tener acceso independiente. Nunca se muestran contraseñas, tokens, enlaces de activación ni datos sensibles.", familyProvisioningUsersPermissionsTitle: "Relación con Usuarios y permisos", familyProvisioningParentOne: "Progenitor 1: cuenta Familia", familyProvisioningFamilyRecord: "Misma ficha de Familia", familyProvisioningParentTwo: "Progenitor 2: cuenta Familia", familyProvisioningUsersPermissionsDescription: "Cada acceso creado para Progenitor 1 o Progenitor 2 genera o vincula una cuenta independiente con rol Familia en Usuarios y permisos, asociada a la misma familia.", familyProvisioningSharedFamily: "Ambos progenitores pueden ver la misma familia y sus hijos.", familyProvisioningSeparateCredentials: "Cada uno entra con su propio usuario y contraseña.", familyProvisioningUsersPermissionsManagement: "Usuarios y permisos sirve para revisar el estado, bloquear o restablecer el acceso.", familyProvisioningFamilyRecordDecision: "La ficha de Familia es el lugar para decidir qué progenitor recibe acceso.", familyProvisioningPlayerEmailNotice: "Modificar el correo en la ficha de un jugador no crea ni envía invitaciones.", familyProvisioningDistinctEmails: "Para dos accesos independientes hacen falta dos correos distintos.",
    bulkAccessIntro: "Selecciona una, varias o todas. No se creará ninguna cuenta ni se enviará ningún correo hasta la confirmación final.",
    searchNameEmail: "Buscar por nombre o correo", selectAllAvailable: "Seleccionar todas las disponibles",
    readyToInvite: "Lista para invitar", invitationPending: "Invitación pendiente", invitationExpired: "Invitación caducada",
    activeAccount: "Cuenta activa", missingValidEmail: "Sin correo válido", loadingCandidates: "Cargando…",
    candidatesLoadError: "No se han podido cargar los candidatos", accountsCreateError: "No se han podido crear las cuentas",
    finalConfirmation: "Confirmación final", bulkConfirmationDetail: "Se crearán o renovarán {count} cuenta(s) y se enviarán las invitaciones por correo.",
    reviewSelection: "Revisar selección", confirmCreateSend: "Confirmar, crear y enviar", processCompleted: "Proceso completado",
    invitationsResult: "{sent} invitación(es) enviada(s). {remaining} registro(s) omitido(s) o pendientes.", playersCount: "{count} jugador(es)",
    roleDefinesFunctionsScopeDefinesData: "El rol define las funciones; el ámbito determina sobre qué datos puede utilizarlas.",
    allowedFunctions: "Funciones permitidas",
    appliedScope: "Ámbito aplicado",
    recipientPreview: "Vista previa de destinatarios",
    recipientPreviewHelp: "Calcula las cuentas y relaciones sin enviar la comunicación.",
    recipientPreviewError: "No se han podido calcular los destinatarios.",
    unresolvedRecipient: "Destinatario histórico sin relación actual",
    activeAccounts: "Cuentas activas",
    availableEmails: "Correos disponibles",
    excludedRecipients: "Destinatarios excluidos",
    preview: "Vista previa",
    send: "Enviar",
    sending: "Enviando…",
    confirmSendCommunication: "Se enviará esta comunicación a",
    recipients: "destinatarios. ¿Quieres continuar?",
    communicationSent: "Comunicación enviada.",
    communicationSendError: "No se ha podido enviar la comunicación.",
    communicationAlreadySent: "La comunicación ya se está enviando o ya fue enviada.",
    communicationGuideTitle: "Cómo crear y enviar una comunicación",
    communicationGuideCollapsed: "Guía práctica de creación, revisión y envío.",
    communicationGuideIntro: "Las comunicaciones se guardan primero como pendientes. Antes de enviarlas, la aplicación comprueba que los destinatarios tengan un contacto válido y autorización para recibir avisos.",
    viewGuide: "Ver guía", hideGuide: "Ocultar guía", reviewAuthorizations: "Revisar autorizaciones",
    communicationGuideStepAuthorizations: "Comprueba las autorizaciones",
    communicationGuideStepAuthorizationsText: "El jugador o su familia debe tener un email válido y el canal Correo electrónico autorizado. Puedes revisarlo desde Autorizaciones.",
    communicationGuideStepCreate: "Crea la comunicación",
    communicationGuideStepCreateText: "Pulsa Añadir, escribe un título y el mensaje, y selecciona los destinatarios disponibles. Puedes elegir equipo, categoría o jugador, además del canal y la prioridad.",
    communicationGuideStepSave: "Guarda y revisa", communicationGuideStepSaveText: "Al crearla quedará como Pendiente. En este momento todavía no se habrá enviado ningún mensaje.",
    communicationGuideStepPreview: "Previsualiza el envío", communicationGuideStepPreviewText: "Pulsa Enviar para comprobar cuántos contactos están disponibles y cuántos han sido excluidos por falta de autorización.",
    communicationGuideStepConfirm: "Confirma", communicationGuideStepConfirmText: "Revisa el resumen y confirma el envío. La aplicación evitará que una comunicación confirmada se envíe dos veces.",
    communicationStatesTitle: "Estados de la comunicación",
    communicationStatePendingText: "Creada, pero todavía no enviada.", communicationStateSendingText: "El proveedor está procesando el envío. No repitas la acción.", communicationStateSentText: "El proveedor ha confirmado la entrega.", communicationStateFailedText: "No se pudo confirmar el envío. Revisa el motivo antes de intentarlo de nuevo.",
    communicationFailureHelpTitle: "¿Por qué ha fallado?",
    communicationFailureAuthorizationText: "No existe ningún contacto autorizado para este envío. Comprueba que el jugador o la familia tenga un email válido y el canal Correo electrónico autorizado.",
    communicationFailureNextStep: "Después de corregir la autorización, vuelve aquí y pulsa Enviar para generar una nueva previsualización.",
    permissionAction_read: "Ver", permissionAction_create: "Crear", permissionAction_edit: "Editar",
    permissionAction_delete: "Anular o eliminar", permissionAction_export: "Exportar",
    permissionAction_administer: "Administrar", permissionAction_respond: "Responder",
    permissionAction_submit: "Recibir documentos",
    permissionResource_dashboard: "Panel principal", permissionResource_users: "Usuarios",
    permissionResource_players: "Jugadores", permissionResource_families: "Familias",
    permissionResource_teams: "Equipos", permissionResource_trainings: "Entrenamientos",
    permissionResource_matches: "Partidos", permissionResource_callups: "Convocatorias",
    permissionResource_attendance: "Asistencia", permissionResource_payments: "Cuotas y pagos",
    permissionResource_authorizations: "Autorizaciones", permissionResource_inscriptions: "Inscripciones",
    permissionResource_communications: "Comunicaciones", permissionResource_reports: "Informes",
    permissionResource_stats: "Estadísticas", permissionResource_search: "Buscador",
    permissionResource_equipment: "Equipamiento", permissionResource_settings: "Configuración",
    permissionResource_modalities: "Modalidades", permissionResource_data: "Administración de datos",
    permissionResource_calendar: "Calendario", permissionResource_portal: "Portal",
    permissionResource_notifications: "Notificaciones", permissionResource_assistant: "Asistente",
    permissionResource_training_evaluations: "Evaluaciones de entrenamientos",
    permissionResource_training_library: "Biblioteca de entrenamientos",
    permissionResource_match_reports: "Actas y rendimiento de partidos",
    more: "Más",
    loading: "Cargando…",
    retry: "Reintentar",
    previous: "Anterior",
    next: "Siguiente",
    loadError: "No hemos podido cargar la información.",
    connectionHint: "Comprueba tu conexión y vuelve a intentarlo.",
    dashboardWelcome: "Todo tu club, de un vistazo",
    dashboardIntro: "Revisa lo importante y continúa desde donde lo dejaste.",
    overview: "Resumen",
    needsAttention: "Requiere atención",
    schedule: "Agenda próxima",
    privacyTitle: "Privacidad y datos",
    privacyBody: "Utilizamos únicamente la cookie de sesión necesaria para mantener tu acceso seguro. No usamos cookies publicitarias ni de seguimiento.",
    understood: "Entendido",
    dismiss: "Cerrar aviso",
    splashBadge: "Gestión deportiva inteligente",
    splashDescription: "Jugadores, familias y competición en un único espacio.",
    enter: "Entrar",
    dashboard: "Panel principal",
    calendar: "Calendario",
    calendarFilters: "Filtros del calendario",
    calendarView: "Vista del calendario",
    calendarView_month: "Mes",
    calendarView_week: "Semana",
    calendarView_agenda: "Agenda",
    calendarType_match: "Partido",
    calendarType_training: "Entrenamiento",
    calendarType_meeting: "Reunión",
    calendarType_club_event: "Evento del club",
    eventType: "Tipo de evento",
    newCalendarEvent: "Nuevo evento",
    editCalendarEvent: "Editar evento",
    calendarLoadError: "No se ha podido cargar el calendario.",
    calendarSaveError: "No se ha podido guardar el evento.",
    calendarExportError: "No se ha podido exportar el calendario.",
    noCalendarEvents: "No hay actividades para este periodo.",
    previousPeriod: "Periodo anterior",
    nextPeriod: "Periodo siguiente",
    today: "Hoy",
    wholeClub: "Todo el club",
    addGoogleCalendar: "Añadir a Google Calendar",
    calendarDetailDescription: "Información del evento deportivo seleccionado.",
    calendarEditorDescription: "Completa los datos de la reunión o evento del club.",
    familyPlayerPortal: "Mi espacio",
    familyPortal: "Portal familiar",
    playerPortal: "Portal del jugador",
    portalSubtitle: "Información deportiva, convocatorias y documentos en un único espacio seguro.",
    selectChild: "Seleccionar hijo/a",
    sportProfile: "Perfil deportivo",
    noTeam: "Sin equipo asignado",
    attendancePercentage: "Porcentaje de asistencia",
    noAttendanceRecords: "Todavía no hay registros de asistencia.",
    noPendingPayments: "No hay pagos pendientes.",
    documentsAndAuthorizations: "Documentos y autorizaciones",
    documentationStatus: "Estado de la documentación",
    signedPdf: "Descargar documento firmado",
    familyAuthOnboardingEyebrow: "Documentación familiar",
    familyAuthOnboardingTitle: "Completa las autorizaciones de tus hijos e hijas",
    familyAuthOnboardingIntro: "Descarga cada autorización, fírmala en papel y súbela, o utiliza la firma sencilla dentro de la aplicación. Puedes continuar usando el portal mientras quede documentación pendiente.",
    familyAuthProgress: "Progreso de autorizaciones",
    familyAuthPending: "Pendiente de recibir",
    familyAuthComplete: "Documento recibido",
    familyAuthPendingNotice: "Hay autorizaciones pendientes de completar.",
    familyAuthBannerDetail: "Pendientes:",
    familyAuthChildren: "Hijos e hijas con autorizaciones",
    familyAuthDownload: "Descargar autorización",
    familyAuthUpload: "Subir documento firmado",
    familyAuthSignElectronically: "Firmar en la aplicación",
    familyAuthSignTitle: "Firma sencilla en la aplicación",
    familyAuthSignHelp: "Dibuja tu firma y confirma el consentimiento.",
    familyAuthSignerName: "Nombre de la persona firmante",
    familyAuthParentLabel: "Progenitor que figura en la autorización",
    familyAuthParentPlaceholder: "Selecciona un progenitor",
    familyAuthParentCurrent: "Cuenta conectada",
    familyAuthParentCurrentNotice: "La cuenta conectada quedará registrada como quien aporta la autorización.",
    familyAuthParentPaperNotice: "Este progenitor aparecerá en la autorización. La cuenta conectada quedará registrada como quien aporta el documento.",
    familyAuthElectronicCurrentOnly: "Para firmar electrónicamente debes iniciar sesión con la cuenta del progenitor seleccionado.",
    familyAuthParentRequired: "Selecciona el progenitor que figura en la autorización.",
    familyAuthParentUnavailable: "No se han podido cargar los progenitores de esta familia.",
    familyAuthSignerRequired: "Escribe el nombre de la persona firmante.",
    familyAuthDrawSignature: "Dibuja tu firma",
    familyAuthClearSignature: "Borrar firma",
    familyAuthSignatureArea: "Área para dibujar la firma",
    familyAuthConsent: "Confirmo que he leído esta autorización y doy mi consentimiento expreso para registrar esta firma sencilla.",
    familyAuthConsentRequired: "Debes confirmar el consentimiento antes de firmar.",
    familyAuthLegalNotice: "Esta es una firma electrónica sencilla y no se presenta como firma cualificada o certificada.",
    familyAuthSaveSignature: "Guardar firma",
    familyAuthNoSignature: "Dibuja tu firma antes de continuar.",
    familyAuthReceived: "Documento recibido correctamente.",
    familyAuthUploadError: "No se ha podido recibir el documento. Comprueba el formato y el tamaño.",
    familyAuthSignatureError: "No se ha podido guardar la firma.",
    familyAuthInvalidType: "Solo se aceptan archivos PDF, JPG, PNG o WEBP.",
    familyAuthInvalidFile: "El archivo no tiene un formato válido.",
    familyAuthFileTooLarge: "El archivo supera el tamaño máximo permitido.",
    familyAuthPermissionError: "No tienes permiso para enviar esta autorización.",
    familyAuthOpen: "Revisar autorizaciones",
    familyAuthLater: "Hacerlo más tarde",
    familyAuthSimpleNotice: "La recepción del documento no implica todavía su validación administrativa.",
    familyPendingResendTitle: "Invitaciones familiares pendientes",
    familyPendingResendDescription: "Renueva y procesa las invitaciones de todas las cuentas familiares que siguen pendientes.",
    familyPendingResendButton: "Reenviar pendientes",
    familyPendingResendResult: "Resultado (enviadas · pendientes · fallidas):",
    familyPendingResendError: "No se han podido reenviar las invitaciones pendientes.",
    authorizationReceivedAt: "Recepción",
    authorizationMode: "Modalidad",
    authorizationReceivedBy: "Recibido por",
    authorizationModeUpload: "Archivo",
    authorizationModeElectronic: "Firma sencilla",
    authorizationSignerParent: "Progenitor que figura en la autorización",
    authorizationSignerParentPlaceholder: "Selecciona un progenitor",
    authorizationSignerParentHint: "El nombre se toma de la ficha de la familia y se valida en el servidor.",
    saving: "Guardando…",
    communication: "Comunicación",
    portalLoadError: "No se ha podido cargar tu espacio personal.",
    portalNoAssociation: "Tu usuario todavía no tiene un jugador o familia asociado.",
    noUpcomingActivities: "No hay actividades próximas.",
    confirmCallupQuestion: "¿Quieres confirmar la asistencia?",
    declineCallupQuestion: "¿Quieres rechazar la convocatoria?",
    playerResponseNotAllowed: "La respuesta directa debe realizarla tu familia.",
    noCallups: "No hay convocatorias disponibles.",
    downloadError: "No se ha podido descargar el documento.",
    authType_general: "Autorización general de participación",
    authType_imagen: "Autorización de uso de imagen",
    authType_medica: "Autorización médica básica",
    authType_desplazamientos: "Autorización de desplazamientos",
    authType_recogida: "Autorización para recogida por terceros",
    authType_proteccion_datos: "Protección de datos",
    notifications: "Notificaciones",
    notificationCenterDescription: "Avisos personales y preferencias de notificación.",
    close: "Cerrar",
    markAllRead: "Marcar todo como leído",
    notificationsLoadError: "No se han podido cargar las notificaciones.",
    noNotifications: "No tienes notificaciones.",
    notificationPreferences: "Preferencias de notificación",
    notificationPref_in_app: "Notificaciones dentro de la aplicación",
    notificationPref_email: "Correo electrónico",
    notificationPref_telegram: "Telegram",
    notificationPref_callups: "Convocatorias",
    notificationPref_schedule_changes: "Horarios y actividades",
    notificationPref_payments: "Pagos",
    notificationPref_documents: "Documentos y autorizaciones",
    providerEmail: "Proveedor de correo",
    providerTelegram: "Bot de Telegram",
    configured: "Configurado",
    notConfigured: "No configurado",
    configuredOptional: "Configurado, pendiente de activación",
    failed: "Fallido",
    deliveryPending: "Pendiente",
    priority: "Prioridad",
    priority_low: "Baja",
    priority_normal: "Normal",
    priority_high: "Alta",
    priority_urgent: "Urgente",
    providerNotConfiguredPending: "El proveedor no está configurado. El envío quedará registrado como pendiente.",
    allDay: "Todo el día",
    title: "Título",
    description: "Descripción",
    location: "Lugar",
    endDate: "Fecha de finalización",
    endTime: "Hora de finalización",
    players: "Jugadores",
    families: "Familias",
    teams: "Equipos",
    matches: "Partidos",
    callups: "Convocatorias",
    payments: "Cuotas y pagos",
    authorizations: "Autorizaciones",
    settings: "Configuración",
    globalSearch: "Buscar en todo",
    globalSearchPlaceholder: "Buscar jugador, equipo, partido, familia…",
    searchNoResults: "Sin resultados",
    globalSearchError: "No se ha podido realizar la búsqueda. Inténtalo de nuevo.",
    searchTypeToStart: "Escribe para buscar en toda la escuela",
    resType_player: "Jugadores",
    resType_team: "Equipos",
    resType_match: "Partidos",
    resType_family: "Familias",
    resType_inscription: "Inscripciones",
    resType_payment: "Pagos",
    inscriptions: "Inscripciones",
    trainings: "Entrenamientos",
    stats: "Estadísticas",
    integralStats: "Estadísticas integrales",
    integralStatsSubtitle: "Indicadores calculados desde los datos deportivos registrados.",
    statisticsFilters: "Filtros estadísticos",
    statisticsOverview: "Resumen general",
    statisticsAttendance: "Asistencia y entrenamientos",
    statisticsMatches: "Partidos y resultados",
    statisticsCallups: "Convocatorias",
    activePlayers: "Jugadores activos",
    scheduledMatches: "Partidos programados",
    playedMatches: "Partidos disputados",
    scheduledTrainings: "Entrenamientos programados",
    completedTrainings: "Entrenamientos realizados",
    registeredResults: "Resultados registrados",
    wins: "Victorias",
    draws: "Empates",
    losses: "Derrotas",
    goalsFor: "Goles a favor",
    goalsAgainst: "Goles en contra",
    sessionsComputable: "Sesiones computables",
    sessionsPending: "Sesiones pendientes",
    attendanceRecords: "Registros de asistencia",
    attendancePercentage: "Porcentaje de asistencia",
    callupsConfirmed: "Confirmadas",
    callupsDeclined: "Rechazadas",
    callupsPending: "Pendientes",
    evolution: "Evolución",
    byTeam: "Desglose por equipo",
    byPlayer: "Desglose por jugador",
    noStatisticsData: "No hay datos suficientes para mostrar este indicador.",
    noTrainingData: "No hay entrenamientos registrados en el periodo seleccionado.",
    noCallupData: "No existen convocatorias suficientes para calcular este indicador.",
    noMatchResult: "El partido no tiene resultado registrado.",
    incompleteStatistics: "Hay datos incompletos; los registros desconocidos no se cuentan como cero.",
    derivedStatisticsNotice: "Las métricas se calculan en el servidor y no se almacenan como totales.",
    manualStatsLegacy: "Registros manuales heredados",
    manualStatsCount: "Registros manuales",
    statisticsExportPdf: "Exportar PDF",
    statisticsExportExcel: "Exportar Excel",
    exportUser: "Usuario generador",
    allStatuses: "Todos los estados",
    activeOnly: "Solo activos",
    inactiveOnly: "Solo inactivos",
    allPlayers: "Todos los jugadores",
    allModalities: "Todas las modalidades",
    clearFilters: "Limpiar filtros",
    statisticsLoadError: "No se pudieron cargar las estadísticas.",
    statisticsExportError: "No se pudo generar la exportación.",
    statisticsAccessDenied: "Las estadísticas internas no están disponibles para este perfil.",
    communications: "Comunicación",
    reports: "Informes",
    modality: "Modalidad",
    professionalReports: "Informes profesionales",
    professionalReportsHelp: "Consulta datos deportivos autorizados con filtros y totales calculados en el servidor.",
    professionalReportsLoadError: "No se pudo cargar el catálogo de informes.",
    professionalReportsPreviewError: "No se pudo generar la vista previa.",
    professionalReportCatalog: "Catálogo de informes",
    reportFilters: "Filtros del informe",
    reportDateFrom: "Fecha inicial",
    reportDateTo: "Fecha final",
    reportPeriod: "Periodo",
    reportWeekly: "Semanal",
    reportMonthly: "Mensual",
    reportGroupBy: "Agrupar por",
    reportByPlayer: "Jugador",
    reportByTeam: "Equipo",
    appliedFilters: "Filtros aplicados",
    previewReport: "Ver vista previa",
    legacyReports: "Informes anteriores",
    professionalExports: "Exportaciones profesionales",
    downloadProfessionalPDF: "Descargar PDF",
    downloadProfessionalExcel: "Descargar Excel",
    preparingExport: "Preparando…",
    professionalExportPreparing: "El archivo se está preparando.",
    professionalExportNoResults: "No hay resultados para exportar.",
    professionalExportError: "No se pudo generar el archivo.",
    professionalExportLimitError: "El informe supera el límite máximo de exportación.",
    reportFilter_season: "Temporada",
    reportFilter_category: "Categoría",
    reportFilter_team_id: "Equipo",
    reportFilter_modality: "Modalidad",
    reportFilter_status: "Estado",
    reportFilter_search: "Búsqueda",
    reportFilter_date_from: "Desde",
    reportFilter_date_to: "Hasta",
    reportFilter_player_id: "Jugador",
    reportFilter_period: "Periodo",
    reportFilter_group_by: "Agrupación",
    reportColumn_name: "Nombre",
    reportColumn_surname: "Apellidos",
    reportColumn_team: "Equipo",
    reportColumn_category: "Categoría",
    reportColumn_modality: "Modalidad",
    reportColumn_number: "Dorsal",
    reportColumn_status: "Estado",
    reportColumn_sessions: "Sesiones",
    reportColumn_present: "Presencias",
    reportColumn_justified: "Justificadas",
    reportColumn_unjustified: "Injustificadas",
    reportColumn_injury: "Lesiones",
    reportColumn_percentage: "Asistencia",
    reportColumn_birth_date: "Fecha de nacimiento",
    reportColumn_position: "Posición",
    reportColumn_license: "Licencia",
    reportColumn_joined_at: "Fecha de alta",
    reportColumn_date: "Fecha",
    reportColumn_time: "Hora",
    reportColumn_location: "Lugar",
    reportColumn_attendees: "Asistentes",
    reportColumn_period_label: "Periodo",
    reportColumn_opponent: "Rival",
    reportColumn_condition: "Condición",
    reportColumn_competition: "Competición",
    reportColumn_score: "Resultado",
    reportColumn_response: "Respuesta",
    reportColumn_responded_at: "Fecha de respuesta",
    reportColumn_late: "Fuera de plazo",
    reportColumn_attendance_status: "Asistencia real",
    reportColumn_consistent: "Coherencia",
    reportColumn_capacity: "Capacidad",
    reportColumn_occupancy: "Ocupación",
    reportColumn_type: "Tipo",
    reportColumn_season: "Temporada",
    reportColumn_movement: "Movimiento",
    reportColumn_document_status: "Estado documental",
    reportColumn_missing_documents: "Documentos pendientes",
    reportColumn_authorization_type: "Tipo de autorización",
    reportColumn_signed_at: "Fecha de firma",
    reportColumn_expires_at: "Caducidad",
    reportColumn_missing_count: "Campos pendientes",
    reportColumn_missing_fields: "Datos pendientes",
    reportColumn_equipment_item: "Equipación",
    reportColumn_shirt_size: "Talla camiseta",
    reportColumn_shorts_size: "Talla pantalón",
    reportColumn_tracksuit_size: "Talla chándal",
    reportColumn_delivered: "Entregada",
    reportColumn_delivery_date: "Fecha de entrega",
    reportColumn_contact_name: "Contacto",
    reportColumn_phone: "Teléfono",
    reportColumn_email: "Correo",
    reportColumn_matches_called: "Convocatorias",
    reportColumn_matches_played: "Partidos jugados",
    reportColumn_minutes: "Minutos",
    reportColumn_goals: "Goles",
    reportColumn_assists: "Asistencias",
    reportColumn_yellow_cards: "Amarillas",
    reportColumn_red_cards: "Rojas",
    reportColumn_rating: "Valoración",
    reportColumn_concept: "Concepto",
    reportColumn_expected: "Previsto",
    reportColumn_paid: "Cobrado",
    reportColumn_pending: "Pendiente",
    reportColumn_payment_method: "Forma de pago",
    reportColumn_payment_date: "Fecha de pago",
    reportColumn_account_holder: "Titular cuenta",
    reportFilter_type: "Tipo",
    reportFilter_movement: "Movimiento",
    reportFilter_delivery: "Entrega",
    reportFilter_contact_type: "Tipo de contacto",
    reportFilter_payment_method: "Forma de pago",
    reportValue_alta: "Alta",
    reportValue_baja: "Baja",
    reportValue_renovacion: "Renovación",
    reportValue_delivered: "Entregada",
    reportValue_pending: "Pendiente",
    reportValue_phone: "Teléfono",
    reportValue_email: "Correo",
    reportValue_domiciliacion: "Domiciliación",
    reportValue_transferencia: "Transferencia",
    reportValue_efectivo: "Efectivo",
    reportValue_bizum: "Bizum",
    reportValue_general: "General",
    reportValue_imagen: "Imagen",
    reportValue_medica: "Médica",
    reportValue_desplazamientos: "Desplazamientos",
    reportValue_recogida: "Recogida",
    reportValue_proteccion_datos: "Protección de datos",
    reportTotal_players: "Jugadores",
    reportTotal_teams: "Equipos",
    reportTotal_groups: "Grupos",
    reportTotal_sessions: "Registros",
    reportTotal_present: "Presencias",
    reportTotal_justified: "Justificadas",
    reportTotal_unjustified: "Injustificadas",
    reportTotal_injury: "Lesiones",
    reportTotal_percentage: "Asistencia (%)",
    reportTotal_rows: "Registros",
    reportTotal_items: "Artículos",
    reportTotal_delivered: "Entregados",
    reportTotal_expected: "Previsto",
    reportTotal_paid: "Cobrado",
    reportTotal_pending: "Pendiente",
    equipment: "Equipamiento",
    equipmentExport: "Exportar CSV",
    equipmentTotalPlayers: "Total jugadores",
    equipmentDelivered: "Equipación entregada",
    equipmentPending: "Pendiente de entregar",
    equipmentMissingSize: "Sin talla registrada",
    equipmentAllTeams: "Todos los equipos",
    equipmentAllDeliveries: "Todas las entregas",
    equipmentPlayerCount: "jugadores",
    equipmentPlayer: "Jugador",
    equipmentTeam: "Equipo",
    equipmentBib: "Dorsal",
    equipmentShirtName: "Nombre camiseta",
    equipmentShirt: "Camiseta",
    equipmentShorts: "Pantalón",
    equipmentTracksuit: "Chándal",
    equipmentSocks: "Medias",
    equipmentShoes: "Calzado",
    equipmentSecondKit: "Segunda equipación",
    equipmentSecondKitShort: "2ª",
    equipmentSecondKitName: "Nombre",
    equipmentSecondKitBib: "Dorsal",
    equipmentSecondKitShirt: "Camiseta",
    equipmentSecondKitSocks: "Medias",
    equipmentDeliveryDate: "Fecha entrega",
    equipmentNotes: "Observaciones",
    equipmentActions: "Acciones",
    equipmentNoResults: "No hay jugadores con los filtros seleccionados",
    equipmentUpdated: "Equipación actualizada",
    equipmentSaveError: "Error al guardar",
    equipmentEditHint: "Edita la equipación con el botón de edición. Los cambios se guardan en la ficha del jugador.",
    equipmentNoTeam: "Sin equipo",
    equipmentKitOverview: "Estado de la equipación",
    equipmentItemsReady: "elementos completos",
    equipmentMissingItems: "pendientes",
    equipmentComplete: "Todo listo",
    equipmentAvailable: "Disponible",
    equipmentCardsView: "Tarjetas",
    equipmentTableView: "Tabla",
    equipmentSearchPlaceholder: "Buscar por nombre, apellidos o equipo",
    equipmentAllSeasons: "Todas las temporadas",
    equipmentOnlyMissingSizes: "Solo con tallas pendientes",
    equipmentViewMode: "Modo de vista",
    equipmentFiltersActive: "Filtros activos",
    equipmentOverviewTitle: "La equipación, de un vistazo",
    equipmentOverviewDescription: "Consulta el avance de las entregas y detecta rápidamente qué falta en cada plantilla.",
    equipmentVisibleSuffix: "visibles",
    equipmentPendingHint: "Pendientes de entregar",
    equipmentMissingSizeHint: "Jugadores con alguna talla pendiente",
    equipmentTeamsSummary: "Estado por equipos",
    equipmentTeamsSummaryDescription: "Selecciona un equipo para revisar sus jugadores y pendientes.",
    equipmentTeamPlayers: "jugadores",
    equipmentDeliveryProgress: "entrega completada",
    equipmentMetadataWarning: "No se ha podido cargar el catálogo de temporadas completo.",
    equipmentTableHint: "Vista compacta para revisar y exportar muchos registros.",
    equipmentSeasonNotice: "Los cambios se guardarán en la temporada seleccionada",
    equipmentMainKit: "Primera equipación",
    equipmentDelivery: "Entrega",
    equipmentSecondKitReadOnly: "La segunda equipación se consulta desde la ficha del jugador.",
    delivered: "Entregada",
    pendingDelivery: "Pendiente",
    yes: "Sí",
    no: "No",
    upcomingTrainings: "Próximos entrenamientos",
    noUpcomingTrainings: "No hay entrenamientos próximos.",
    // Inscriptions
    inscriptionType: "Tipo",
    alta: "Alta nueva",
    renovacion: "Renovación",
    review: "Revisar",
    createPlayerFromInscription: "Crear ficha de jugador",
    possibleSibling: "Posible hermano",
    inscriptionStatus: "Estado de inscripción",
    convertedPlayer: "Ficha creada",
    // Trainings
    attendance: "Asistencia",
    present: "Presente",
    justified: "Falta justificada",
    unjustified: "Falta sin justificar",
    injury: "Lesión",
    exercises: "Ejercicios trabajados",
    coachNotes: "Observaciones del entrenador",
    trainingEvaluations: "Evaluaciones individuales",
    openTrainingEvaluations: "Evaluar jugadores",
    evaluationSummary: "Resumen de evaluaciones",
    evaluationEvaluated: "Evaluados",
    evaluationPending: "Pendientes",
    evaluationIncomplete: "Incompletas",
    evaluationAbsent: "Ausentes",
    evaluationFilter: "Filtrar jugadores",
    evaluationFilterAll: "Todos los jugadores",
    evaluationFilterEvaluated: "Evaluados",
    evaluationFilterPending: "Pendientes",
    evaluationFilterAbsent: "Ausentes",
    evaluationFilterIncomplete: "Incompletas",
    evaluationAttendance: "Asistencia registrada",
    evaluationParticipation: "Participación",
    evaluationAttitude: "Actitud",
    evaluationEffort: "Esfuerzo",
    evaluationTacticalUnderstanding: "Comprensión táctica",
    evaluationTechnique: "Técnica",
    evaluationFitness: "Condición física",
    evaluationObservations: "Observaciones internas",
    evaluationIncidents: "Incidencias internas",
    evaluationScale: "Escala 1–5; no es una medición clínica",
    evaluationNoScoresAbsent: "Sin puntuaciones: el jugador no consta como presente",
    evaluationDraft: "Borrador",
    evaluationCompleted: "Completada",
    evaluationClosed: "Cerrada",
    evaluationSave: "Guardar evaluación",
    evaluationSaveAll: "Guardar cambios",
    evaluationClose: "Cerrar evaluación",
    evaluationCloseConfirm: "¿Cerrar esta evaluación? Después no se podrá editar.",
    evaluationHistory: "Historial del jugador",
    evaluationHistoryEmpty: "Todavía no hay evaluaciones históricas.",
    evaluationLoadError: "No se han podido cargar las evaluaciones.",
    evaluationSaveError: "No se ha podido guardar la evaluación.",
    evaluationSaved: "Evaluación guardada",
    evaluationClosedSuccess: "Evaluación cerrada",
    evaluationNoPlayers: "No hay jugadores en el equipo.",
    evaluationNoAttendance: "Sin asistencia registrada",
    evaluationInternalHint: "Contenido interno para personal autorizado.",
    matchReportAction: "Acta y rendimiento",
    matchReportTitle: "Acta profesional y rendimiento",
    matchReportInternalHint: "Información deportiva interna disponible únicamente para personal autorizado.",
    matchReportHeader: "Cabecera del acta",
    matchReportVersion: "Versión",
    matchReportOrigin: "Origen",
    matchReportAuthor: "Autor",
    matchReportCreatedAt: "Creada",
    matchReportUpdatedAt: "Última modificación",
    matchReportClosedAt: "Cerrada",
    matchReportReopenedAt: "Reabierta",
    matchReportCallupSummary: "Resumen de convocatoria",
    matchReportNoCallup: "Sin convocatoria",
    matchReportEmpty: "Todavía no existe un acta para este partido.",
    matchReportCreateDraft: "Crear borrador",
    matchReportDraftCreated: "Borrador de acta creado",
    matchReportObjectiveSummary: "Resumen objetivo del partido",
    matchReportCalled: "Convocados",
    matchReportStarters: "Titulares",
    matchReportPlayed: "Participaron",
    matchReportMinutes: "Minutos",
    matchReportParticipants: "Participantes",
    matchReportParticipationRole: "Situación",
    matchReportInitialPosition: "Posición inicial",
    matchReportStarter: "Titular",
    matchReportSubstitute: "Suplente",
    matchReportDidNotPlay: "No participa",
    matchReportAbsent: "Ausencia",
    matchReportLateWithdrawal: "Baja de última hora",
    matchReportNotCalled: "No convocado",
    matchReportParticipated: "Jugó",
    matchReportOwnGoals: "Goles en propia puerta",
    matchReportEntries: "Entradas",
    matchReportExits: "Salidas",
    matchReportPeriods: "Periodos",
    matchReportInitialPeriod: "Periodo inicial",
    matchReportFinalPeriod: "Periodo final",
    matchReportNoPeriod: "Sin periodo",
    matchReportChanges: "Cambios",
    matchReportAddChange: "Añadir cambio",
    matchReportEntry: "Entrada",
    matchReportExit: "Salida",
    matchReportMinute: "Minuto",
    matchReportRemoveChange: "Eliminar cambio",
    matchReportNonParticipationReason: "Motivo de no participación",
    matchReportExceptionalReason: "Motivo de incorporación excepcional",
    matchReportAvailabilityOverrideReason: "Motivo de participación tras rechazar la convocatoria",
    matchReportMinutesOverrideReason: "Motivo administrativo para superar la duración",
    matchReportConfirmException: "Confirmo que esta excepción ha sido revisada",
    matchReportSubstitutions: "Sustituciones",
    matchReportAddSubstitution: "Añadir sustitución",
    matchReportNoSubstitutions: "No hay sustituciones registradas.",
    matchReportIncomingPlayer: "Jugador que entra",
    matchReportOutgoingPlayer: "Jugador que sale",
    matchReportObjectiveNote: "Observación objetiva",
    matchReportRemoveSubstitution: "Eliminar sustitución",
    matchReportGoalEvents: "Goles del equipo",
    matchReportAddGoal: "Añadir gol",
    matchReportNoGoals: "No hay goles registrados.",
    matchReportGoalType: "Tipo de gol",
    matchReportGoalPlayer: "Gol de jugador",
    matchReportOpponentOwnGoal: "Autogol del rival",
    matchReportUnidentifiedGoal: "Gol sin autor identificado",
    matchReportScorer: "Goleador",
    matchReportRemoveGoal: "Eliminar gol",
    matchReportScoreDiscrepancyReason: "Justificación administrativa de la diferencia con el marcador",
    matchReportUnsavedChanges: "Hay cambios sin guardar.",
    matchReportDiscardChanges: "Hay cambios sin guardar. ¿Quieres descartarlos?",
    matchReportExportPdf: "Exportar acta PDF",
    matchReportExportError: "No se ha podido exportar el acta.",
    matchReportIncidents: "Incidencias deportivas",
    matchReportInternalNotes: "Observaciones internas",
    matchReportGeneralNotes: "Observaciones generales del acta",
    matchReportValidation: "Validaciones y advertencias",
    matchReportValid: "El acta cumple las reglas de cierre.",
    matchReportValidate: "Validar acta",
    matchReportSaveDraft: "Guardar borrador",
    matchReportSaved: "Borrador guardado",
    matchReportClose: "Cerrar acta",
    matchReportCloseConfirm: "¿Cerrar el acta? Quedará bloqueada para edición ordinaria.",
    matchReportConfirmWarnings: "El acta contiene advertencias. ¿Confirmas que las has revisado?",
    matchReportClosedSuccess: "Acta cerrada",
    matchReportReopen: "Reabrir acta",
    matchReportReopenReason: "Motivo obligatorio de reapertura",
    matchReportReopenedSuccess: "Acta reabierta y auditada",
    matchReportHistory: "Historial de cambios",
    matchReportHistoryEmpty: "Todavía no hay cambios registrados.",
    matchReportNoPlayers: "No hay jugadores elegibles en el equipo.",
    matchReportLoadError: "No se ha podido cargar el acta.",
    matchReportSaveError: "No se ha podido guardar el borrador.",
    matchReportValidationError: "No se ha podido validar el acta.",
    matchReportCloseError: "No se ha podido cerrar el acta.",
    matchReportReopenError: "No se ha podido reabrir el acta.",
    present_short: "Presentes",
    manageAttendance: "Gestionar asistencia",
    attendanceRate: "Asistencia",
    attendanceAlertThreshold: "Ausencias para alertar",
    attendanceAlerts: "alertas por ausencias reiteradas",
    attendanceReason: "Motivo (opcional)",
    attendanceLoadError: "No se ha podido cargar la asistencia",
    attendanceExportError: "No se ha podido exportar la asistencia",
    exerciseLibrary: "Biblioteca de ejercicios",
    preparedTrainingLibrary: "Biblioteca de entrenamientos",
    preparedTrainingLibraryDescription: "Elige una tarea preparada y úsala al programar una sesión.",
    refreshTrainingLibrary: "Actualizar catálogo",
    trainingBlock: "Bloque de trabajo",
    trainingSubblock: "Subbloque",
    allTrainingBlocks: "Todos los bloques",
    allTrainingSubblocks: "Todos los subbloques",
    preparedTrainingCount: "Entrenamientos disponibles",
    catalogExpected: "Esperados en el índice",
    noPreparedTrainings: "No hay entrenamientos preparados que coincidan con los filtros.",
    trainingLibraryLoadError: "No se ha podido cargar la biblioteca de entrenamientos",
    trainingLibrarySyncError: "No se ha podido actualizar la biblioteca de entrenamientos",
    viewPdf: "Ver PDF",
    usePreparedTraining: "Usar en entrenamiento",
    choosePreparedTraining: "Elegir de la biblioteca",
    noPreparedTrainingSelected: "No se ha seleccionado ningún entrenamiento preparado",
    allTeams: "Todos los equipos",
    duplicate: "Duplicar",
    duration: "Duración",
    objective: "Objetivo",
    exerciseLibraryDescription: "Crea, reutiliza y evalúa ejercicios dentro del ámbito autorizado.",
    allObjectives: "Todos los objetivos",
    allAuthors: "Todos los autores",
    exerciseAuthor: "Autor",
    sortBy: "Ordenar por",
    sortNameAsc: "Nombre A–Z",
    sortNameDesc: "Nombre Z–A",
    sortDurationAsc: "Duración menor a mayor",
    sortDurationDesc: "Duración mayor a menor",
    exerciseImageUrl: "Imagen o esquema (URL opcional)",
    viewDetails: "Ver detalle",
    noDescription: "Sin descripción",
    exerciseFormDescription: "Define el ejercicio reutilizable y su ámbito de visibilidad.",
    exercisePickerDescription: "Busca y selecciona uno o varios ejercicios para esta sesión.",
    templateFormDescription: "Guarda una copia independiente de la planificación actual.",
    trainingFormDescription: "Planifica la sesión y registra después la asistencia y el trabajo realizado.",
    trainingSessions: "Sesiones",
    createExercise: "Crear ejercicio",
    editExercise: "Editar ejercicio",
    exerciseSaved: "Ejercicio guardado",
    exerciseDuplicated: "Ejercicio duplicado",
    exerciseLibraryLoadError: "No se ha podido cargar la biblioteca de ejercicios",
    noExercises: "No hay ejercicios que coincidan con los filtros.",
    exerciseCount: "Ejercicios",
    plannedUses: "Usos planificados",
    allCategories: "Todas las categorías",
    archived: "Archivado",
    archive: "Archivar",
    restore: "Restaurar",
    confirmArchiveExercise: "¿Archivar este ejercicio? Seguirá visible en los entrenamientos históricos.",
    confirmRestoreExercise: "¿Restaurar este ejercicio?",
    recommendedDuration: "Duración recomendada (min)",
    exerciseInstructions: "Instrucciones paso a paso",
    materials: "Material necesario",
    safetyNotes: "Observaciones de seguridad",
    intensity: "Intensidad",
    recommendedSpace: "Espacio recomendado",
    minPlayers: "Mínimo de jugadores",
    maxPlayers: "Máximo de jugadores",
    exerciseMaxPlayers: "Máximo de jugadores",
    exerciseRating: "Valoración del ejercicio",
    visibility: "Visibilidad",
    authorizedTeams: "Equipos autorizados",
    intensity_low: "Baja", intensity_medium: "Media", intensity_high: "Alta",
    exerciseVisibility_private: "Privado del creador",
    exerciseVisibility_teams: "Equipos autorizados",
    exerciseVisibility_club: "Todo el club",
    exerciseCategory_warmup: "Calentamiento",
    exerciseCategory_technique: "Técnica",
    exerciseCategory_tactics: "Táctica",
    exerciseCategory_fitness: "Preparación física",
    exerciseCategory_goalkeepers: "Porteros",
    exerciseCategory_finishing: "Finalización",
    exerciseCategory_possession: "Posesión",
    exerciseCategory_small_sided_game: "Partido reducido",
    exerciseCategory_set_pieces: "Estrategia",
    exerciseCategory_cooldown: "Vuelta a la calma",
    exerciseCategory_other: "Otro",
    plannedExercises: "Ejercicios planificados",
    plannedExercisesHelp: "Ordena la sesión y completa la evaluación después del entrenamiento.",
    addExercise: "Añadir ejercicio",
    addSelected: "Añadir seleccionados",
    availableExercises: "Ejercicios disponibles",
    noPlannedExercises: "Todavía no hay ejercicios planificados.",
    plannedDuration: "Duración prevista (min)",
    actualDuration: "Duración real (min)",
    performed: "Realizado",
    rating: "Valoración",
    exerciseRating_very_good: "Muy bien",
    exerciseRating_good: "Bien",
    exerciseRating_needs_improvement: "Mejorable",
    exerciseRating_poor: "Mal",
    exerciseObservation: "Observación específica",
    notCompletedReason: "Motivo de no realización",
    notCompletedReasonRequired: "Indica el motivo de los ejercicios no realizados.",
    markAllPerformed: "Marcar todos como realizados",
    moveUp: "Subir",
    moveDown: "Bajar",
    remove: "Retirar",
    saveAsTemplate: "Guardar como plantilla",
    templateSaved: "Plantilla guardada",
    loadTemplate: "Cargar plantilla de sesión",
    copyPreviousTraining: "Copiar de otro entrenamiento",
    confirmApplyTemplate: "¿Sustituir la planificación actual por esta plantilla?",
    confirmCopyExercises: "¿Copiar los ejercicios de este entrenamiento?",
    historicalExerciseRecord: "Registro histórico",
    duplicateTrainingDate: "Fecha del nuevo entrenamiento (AAAA-MM-DD)",
    trainingDuplicated: "Sesión duplicada",
    // Stats
    calledMatches: "Convocado",
    playedMatches: "Jugados",
    minutes: "Minutos",
    goals: "Goles",
    assists: "Asistencias",
    yellowCards: "T. amarillas",
    redCards: "T. rojas",
    cleanSheets: "Porterías a cero",
    rating: "Valoración (1-10)",
    sportNotes: "Observaciones deportivas",
    // Communications
    recipientType: "Destinatario",
    byTeam: "Por equipo",
    byCategory: "Por categoría",
    individual: "Individual",
    channel: "Canal",
    subject: "Asunto",
    message: "Mensaje",
    sent: "Enviado",
    sendDate: "Fecha de envío",
    markSent: "Marcar como enviado",
    history: "Historial de mensajes",
    // Reports
    playersList: "Listado de jugadores",
    familyPhones: "Teléfonos de familias",
    familyEmails: "Correos de familias",
    pendingPaymentsReport: "Pagos pendientes",
    pendingAuthsReport: "Autorizaciones pendientes",
    statsReport: "Estadísticas por jugador",
    exportCSV: "Exportar Excel/CSV",
    exportPDF: "Imprimir / PDF",
    selectReport: "Selecciona un informe",
    rows: "filas",
    activePlayers: "Jugadores activos",
    newInscriptions: "Nuevas inscripciones",
    pendingInscriptions: "Inscripciones pendientes",
    pendingDocs: "Documentación pendiente",
    pendingPayments: "Pagos pendientes",
    upcomingMatches: "Próximos partidos",
    importantAlerts: "Alertas importantes",
    quickActions: "Accesos rápidos",
    newPlayer: "Nuevo jugador",
    newMatch: "Nuevo partido",
    newCallup: "Nueva convocatoria",
    newAuthorization: "Nueva autorización",
    newPayment: "Nuevo pago",
    newTeam: "Nuevo equipo",
    noAlerts: "Sin alertas. Todo en orden.",
    noUpcoming: "No hay partidos próximos programados.",
    totalPlayers: "jugadores en total",
    pendingAmount: "importe pendiente",
    dashboardFilters: "Filtros del panel",
    nextActivity: "Siguiente actividad",
    noNextActivity: "No hay actividades futuras programadas.",
    weeklySummary: "Resumen semanal",
    pendingCallups: "Convocatorias pendientes",
    pendingCommunications: "Comunicaciones pendientes",
    latestCommunications: "Últimas comunicaciones",
    noCommunications: "No hay comunicaciones disponibles.",
    availablePlayers: "Jugadores disponibles",
    absentPlayers: "Jugadores ausentes",
    associatedChildren: "Hijos asociados",
    callupStatus: "Estado de convocatoria",
    incidents: "Incidencias",
    noIncidents: "No hay incidencias.",
    // Common
    search: "Buscar...",
    add: "Añadir",
    save: "Guardar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Eliminar",
    view: "Ver",
    print: "Imprimir / PDF",
    actions: "Acciones",
    name: "Nombre",
    surname: "Apellidos",
    status: "Estado",
    category: "Categoría",
    team: "Equipo",
    all: "Todos",
    none: "Ninguno",
    yes: "Sí",
    no: "No",
    noData: "No hay registros todavía.",
    confirmDelete: "¿Seguro que quieres eliminar este registro?",
    saved: "Guardado correctamente",
    deleted: "Eliminado correctamente",
    // Player form tabs
    tabPersonal: "Personal",
    tabSport: "Deportivo",
    tabFamily: "Familia",
    tabHealth: "Salud",
    tabKit: "Equipación",
    tabDocs: "Documentación",
    // Player fields
    birthdate: "Fecha de nacimiento",
    school: "Centro escolar",
    enrollDate: "Fecha de inscripción",
    formEmail: "Email del formulario",
    address: "Domicilio",
    parent1: "Padre / Progenitor 1",
    parent2: "Madre / Progenitor 2",
    phone: "Teléfono",
    email: "Email",
    photo: "Foto del jugador",
    number: "Dorsal",
    position: "Posición habitual",
    license: "Nº de licencia",
    altaDate: "Fecha de alta",
    bajaDate: "Fecha de baja",
    newPlayerFlag: "Nueva incorporación",
    secondSibling: "Segundo hermano",
    discount: "Descuento aplicado (€)",
    notes: "Observaciones internas",
    allergies: "Alergias",
    diseases: "Enfermedades relevantes",
    medication: "Medicación",
    medicalInsurance: "Seguro médico",
    emergencyContact: "Contacto de emergencia",
    emergencyPhone: "Teléfono de emergencia",
    medicalNotes: "Observaciones médicas",
    shirtSize: "Talla camiseta",
    pantsSize: "Talla pantalón",
    tracksuitSize: "Talla chándal",
    socksSize: "Talla medias",
    shoeSize: "Talla calzado",
    kitDelivered: "Equipación entregada",
    deliveryDate: "Fecha de entrega",
    kitNotes: "Observaciones de material",
    docStatus: "Estado documental",
    reviewDate: "Fecha de revisión",
    // Team fields
    season: "Temporada",
    teamsIntro: "Organiza las plantillas por temporada y accede a sus jugadores sin mezclar historiales.",
    teamsSummary: "Resumen de equipos",
    seasonFoldersTitle: "Temporadas",
    seasonFoldersDescription: "Selecciona una temporada para ver únicamente sus equipos y plantillas.",
    createNextSeason: "Crear temporada siguiente",
    createNextSeasonTitle: "Crear temporada siguiente",
    createNextSeasonDescription: "Crea equipos nuevos con la misma estructura y prepara sus plantillas sin modificar la temporada anterior.",
    sourceSeason: "Temporada de origen",
    targetSeason: "Nueva temporada",
    seasonCopyWarning: "Se conservarán los equipos y jugadores de la temporada anterior como punto de partida. Después podrás cambiar altas, bajas y equipos en la nueva temporada; el histórico anterior permanecerá intacto.",
    seasonCopyConfirm: "¿Crear la nueva temporada copiando sus equipos y plantillas?",
    seasonCopyRequired: "Selecciona la temporada de origen y escribe la nueva temporada.",
    seasonCopyDifferent: "La temporada nueva debe ser diferente de la temporada de origen.",
    seasonAlreadyExists: "La temporada de destino ya existe.",
    seasonCopySuccess: "Temporada creada correctamente:",
    seasonCopyError: "No se pudo crear la temporada.",
    copyingSeason: "Creando temporada…",
    teamsCount: "equipos",
    selectedSeason: "Temporada seleccionada",
    viewTeams: "Ver equipos",
    viewPlayers: "Ver jugadores",
    unassignedSeason: "Sin temporada",
    seasonNoTeams: "No hay equipos asignados a esta temporada.",
    noFilteredTeams: "No hay equipos que coincidan con los filtros seleccionados.",
    searchTeamsPlaceholder: "Buscar por nombre, categoría o entrenador",
    allCategories: "Todas las categorías",
    clearTeamFilters: "Limpiar filtros",
    coach: "Entrenador",
    secondCoach: "Segundo entrenador",
    delegate: "Delegado",
    trainingDays: "Días de entrenamiento",
    schedule: "Horario",
    field: "Campo",
    maxPlayers: "Límite de jugadores",
    roster: "Plantilla",
    playersCount: "jugadores",
    // Family
    mainContact: "Persona principal de contacto",
    commPreference: "Preferencia de comunicación",
    children: "Hijos inscritos",
    // Match
    matchday: "Jornada",
    date: "Fecha",
    time: "Hora",
    ownTeam: "Equipo propio",
    rival: "Rival",
    homeAway: "Local / Visitante",
    home: "Local",
    away: "Visitante",
    fieldAddress: "Dirección del campo",
    matchType: "Tipo de partido",
    result: "Resultado",
    ownResult: "Resultado propio",
    rivalResult: "Resultado rival",
    // Callup
    match: "Partido",
    calledPlayers: "Jugadores convocados",
    notCalledPlayers: "Jugadores no convocados",
    meetTime: "Hora de quedada",
    meetPlace: "Lugar de quedada",
    material: "Material necesario",
    messageFamilies: "Mensaje a familias",
    selectPlayers: "Selecciona jugadores",
    pending: "pendientes",
    confirmed: "confirmados",
    declined: "rechazados",
    searchPlayer: "Buscar jugador",
    filterByStatus: "Filtrar por estado",
    allStatuses: "Todos los estados",
    responseDeadline: "Fecha límite de respuesta",
    deadlineExpired: "Plazo vencido",
    confirmAttendance: "Confirmar",
    declineAttendance: "Rechazar",
    confirmAllPending: "Confirmar pendientes",
    declineAllPending: "Rechazar pendientes",
    confirmAllPendingQuestion: "¿Quieres confirmar todos los jugadores pendientes de esta convocatoria?",
    declineAllPendingQuestion: "¿Quieres rechazar todos los jugadores pendientes de esta convocatoria?",
    confirmSave: "¿Quieres guardar esta respuesta?",
    declineReasonOptional: "Motivo del rechazo (opcional)",
    responseSaved: "Respuesta guardada",
    bulkResponseSaved: "{count} respuestas actualizadas",
    bulkResponseError: "No se han podido actualizar las respuestas pendientes.",
    reason: "Motivo",
    selectMatch: "Selecciona un partido",
    editCallup: "Editar convocatoria",
    teamPlayers: "Jugadores del equipo",
    reinforcements: "Refuerzos de otros equipos",
    downloadPdf: "Descargar PDF bilingüe",
    allowPlayerResponse: "Permitir que el jugador responda directamente",
    // Payment
    paymentPlayer: "Jugador/a asociado",
    paymentPlayerColumn: "Jugador/a",
    concept: "Concepto",
    baseAmount: "Importe base (€)",
    siblingDiscount: "Descuento hermano (€)",
    finalAmount: "Importe final (€)",
    accountHolder: "Titular de la cuenta",
    paymentMethod: "Forma de pago",
    iban: "Cuenta bancaria / IBAN",
    paymentDate: "Fecha de pago",
    // Authorization
    authType: "Tipo de autorización",
    authorizedPerson: "Persona autorizada para recoger",
    authorizedDni: "DNI persona autorizada",
    signer: "Firmante (padre/madre/tutor)",
    signDate: "Fecha de firma",
    expiryDate: "Fecha de caducidad",
    // Settings
    clubData: "Datos del club",
    clubName: "Nombre del club",
    clubAddress: "Dirección",
    clubEmail: "Email del club",
    clubPhone: "Teléfono del club",
    currentSeason: "Temporada actual",
    seasons: "Temporadas",
    fields: "Campos de juego",
    coaches: "Entrenadores",
    baseFee: "Cuota base (€)",
    siblingDiscountCfg: "Descuento por hermano (€)",
    categoriesByAge: "Categorías por edad",
    addItem: "Añadir (Enter)",
    quickStart: "Empieza dando de alta tu primer jugador",
    dataManagement: "Datos y base de datos",
    exportDB: "Exportar a Excel",
    importDB: "Importar desde Excel",
    loadDemo: "Cargar datos de ejemplo",
    clearAll: "Vaciar todo",
    exportDBDesc: "Descarga toda la base de datos (jugadores, equipos, partidos, etc.) en un archivo Excel con una hoja por módulo.",
    importDBDesc: "Sube un archivo Excel para reemplazar la base de datos. Usa el mismo formato que la exportación.",
    importWarning: "Esto reemplazará los datos actuales. ¿Continuar?",
    clearWarning: "Se borrarán TODOS los datos. ¿Seguro?",
    demoWarning: "Esto reemplazará los datos actuales con datos de ejemplo. ¿Continuar?",
    importDone: "Importación completada",
    exporting: "Exportando…",
    importing: "Importando…",
    assistantOpen: "Abrir asistente de ayuda",
    assistantIdentity: "Laguntxi · Asistente de Ikastxiki",
    assistantShort: "Asistente",
    assistantTitle: "Laguntxi · Asistente de Ikastxiki",
    assistantDescription: "Ayuda contextual y gestión guiada con confirmación.",
    assistantWelcomeTitle: "Hola, soy la mascota de Ikastxiki.",
    assistantWelcomeDescription: "Estoy aquí para ayudarte con la gestión del club.",
    assistantPrivacyWarning: "Es un asistente de IA. No introduzcas DNI, IBAN, datos médicos, contraseñas ni documentación privada.",
    assistantCurrentContext: "Estás consultando",
    assistantAvailableModules: "Explorar Ikas‑Txiki",
    assistantAvailableModulesHelp: "Accesos disponibles para tu rol. El asistente nunca muestra módulos sin permiso.",
    assistantOrientation: "Te ayudo a encontrarlo",
    assistantQuickLinks: "Accesos rápidos",
    assistantQuickGuide: "Guía rápida",
    assistantOpenCurrentModule: "Abrir esta pantalla",
    assistantReviewTitle: "Para revisar",
    assistantReviewLoading: "Actualizando información segura…",
    assistantReviewError: "No se ha podido actualizar la información del asistente",
    assistantReviewEmpty: "Todo está al día por ahora.",
    assistantHideReview: "Ocultar este aviso durante esta sesión",
    assistantReview_authorizations_pending: "autorizaciones pendientes de revisar",
    assistantReview_callups_pending: "convocatorias pendientes de responder",
    assistantReview_communications_attention: "comunicaciones requieren atención",
    assistantReview_attendance_alerts: "alertas de asistencia en tus equipos",
    assistantReview_payments_pending: "pagos pendientes de revisar",
    assistantReview_next_activity: "Tienes una actividad próxima",
    assistantDailyWelcome_users: "Desde aquí puedes localizar la gestión de cuentas, roles y seguridad del club.",
    assistantDailyWelcome_families: "Aquí encontrarás las relaciones familiares autorizadas y sus fichas vinculadas.",
    assistantDailyWelcome_players: "Aquí puedes orientar la consulta y gestión de fichas dentro de tu ámbito.",
    assistantDailyWelcome_communications: "Aquí puedes localizar las comunicaciones autorizadas antes de prepararlas en su módulo.",
    assistantDailyWelcome_authorizations: "Aquí puedes revisar el circuito de autorizaciones permitido para tu rol.",
    assistantDailyWelcome_payments: "Aquí puedes consultar la gestión económica autorizada sin realizar cobros desde el asistente.",
    assistantDailyWelcome_trainings: "Aquí puedes localizar la planificación, ejercicios y asistencia de entrenamientos.",
    assistantDailyWelcome_reports: "Aquí puedes localizar informes y sus filtros antes de previsualizar o exportar.",
    assistantDailyWelcome_settings: "Aquí puedes localizar los ajustes administrativos disponibles para tu rol.",
    assistantDailyGuide_users_1: "Revisa las cuentas y su estado.", assistantDailyGuide_users_2: "Comprueba el rol y el ámbito antes de modificar nada.", assistantDailyGuide_users_3: "Realiza los cambios desde Usuarios con confirmación.",
    assistantDailyGuide_families_1: "Busca la familia dentro de tu ámbito.", assistantDailyGuide_families_2: "Comprueba la relación con la ficha correspondiente.", assistantDailyGuide_families_3: "Actualiza solo desde el formulario autorizado.",
    assistantDailyGuide_players_1: "Localiza la ficha del jugador permitida.", assistantDailyGuide_players_2: "Revisa equipo, categoría y estado.", assistantDailyGuide_players_3: "Usa el formulario del módulo para cualquier cambio.",
    assistantDailyGuide_communications_1: "Abre Comunicaciones.", assistantDailyGuide_communications_2: "Selecciona únicamente destinatarios autorizados.", assistantDailyGuide_communications_3: "Revisa el contenido antes de enviarlo desde el módulo.",
    assistantDailyGuide_authorizations_1: "Abre Autorizaciones.", assistantDailyGuide_authorizations_2: "Revisa el estado permitido para tu rol.", assistantDailyGuide_authorizations_3: "Descarga o gestiona el documento desde su flujo oficial.",
    assistantDailyGuide_payments_1: "Abre Cuotas y pagos.", assistantDailyGuide_payments_2: "Revisa el estado económico permitido.", assistantDailyGuide_payments_3: "Gestiona cualquier cambio desde el módulo oficial.",
    assistantDailyGuide_trainings_1: "Abre Entrenamientos.", assistantDailyGuide_trainings_2: "Elige la sesión dentro de tu ámbito.", assistantDailyGuide_trainings_3: "Planifica o registra asistencia desde el flujo autorizado.",
    assistantDailyGuide_reports_1: "Abre Informes.", assistantDailyGuide_reports_2: "Aplica los filtros necesarios.", assistantDailyGuide_reports_3: "Previsualiza o exporta solo desde el módulo.",
    assistantDailyGuide_settings_1: "Abre Configuración.", assistantDailyGuide_settings_2: "Revisa el ajuste que necesitas.", assistantDailyGuide_settings_3: "Guarda cambios únicamente desde su formulario oficial.",
    assistantGeneralHelp: "Ayuda de utilización",
    assistantGuidedManagement: "Acciones guiadas",
    assistantGuidedDescription: "Los cambios se preparan primero y nunca se guardan sin una confirmación explícita.",
    assistantQuestionScreen: "¿Qué puedo hacer en esta pantalla?",
    assistantQuestionPermissions: "¿Qué opciones permite mi rol?",
    assistantQuestionDashboard: "¿Cómo interpreto el panel principal?",
    assistantQuestionPlayer: "¿Cómo se gestiona una ficha de jugador?",
    assistantQuestionFamily: "¿Cómo se relaciona una familia con un jugador?",
    assistantQuestionTeam: "¿Cómo consulto y gestiono la plantilla de un equipo?",
    assistantQuestionInscription: "¿Cómo reviso una inscripción o un borrador de Excel?",
    assistantQuestionTraining: "¿Cómo planifico un entrenamiento y registro asistencia?",
    assistantQuestionMatch: "¿Cómo preparo un partido, su acta y el rendimiento?",
    assistantQuestionAttendance: "¿Cómo se registra la asistencia?",
    assistantQuestionCallup: "¿Cómo funciona una convocatoria?",
    assistantQuestionPayment: "¿Cómo reviso cuotas y pagos sin crear deudas incorrectas?",
    assistantQuestionAuthorization: "¿Cómo reviso las autorizaciones pendientes?",
    assistantQuestionEquipment: "¿Cómo gestiono tallas, entregas y equipaciones?",
    assistantQuestionCommunication: "¿Cómo preparo una comunicación para el grupo correcto?",
    assistantQuestionCalendar: "¿Cómo consulto partidos, entrenamientos y eventos?",
    assistantQuestionReports: "¿Cómo uso y exporto un informe?",
    assistantQuestionStats: "¿Cómo aplico filtros e interpreto las estadísticas?",
    assistantQuestionSettings: "¿Cómo configuro el club de forma segura?",
    assistantQuestionUsers: "¿Cómo administro usuarios, roles y seguridad?",
    assistantQuestionPortal: "¿Qué puede consultar una familia o un jugador en el portal?",
    assistantModule_dashboard: "Panel principal", assistantModule_players: "Jugadores",
    assistantModule_families: "Familias", assistantModule_teams: "Equipos",
    assistantModule_inscriptions: "Inscripciones", assistantModule_trainings: "Entrenamientos",
    assistantModule_matches: "Partidos", assistantModule_callups: "Convocatorias",
    assistantModule_payments: "Cuotas y pagos", assistantModule_authorizations: "Autorizaciones",
    assistantModule_equipment: "Equipamiento", assistantModule_communications: "Comunicaciones",
    assistantModule_calendar: "Calendario", assistantModule_reports: "Informes",
    assistantModule_stats: "Estadísticas", assistantModule_settings: "Configuración",
    assistantModule_users: "Usuarios, roles y seguridad", assistantModule_portal: "Portal",
    assistantModule_unknown: "Esta pantalla",
    assistantGeneralChannel: "Ayuda general",
    assistantInternalChannel: "Canal interno seguro",
    assistantProcessedInternally: "Por privacidad, esta consulta se ha mantenido dentro de Ikas‑Txiki.",
    assistantOpenModule: "Abrir módulo",
    assistantQuestion: "Pregunta para el asistente",
    assistantPlaceholder: "Pregunta cómo utilizar esta pantalla…",
    assistantSend: "Enviar pregunta",
    assistantAction: "Operación",
    assistantSelectAction: "Selecciona una operación",
    assistantTargetId: "Identificador del registro",
    assistantPreparePreview: "Preparar vista previa",
    assistantExactPreview: "Vista previa exacta del cambio",
    assistantPossibleDuplicates: "Se han detectado posibles coincidencias. Revísalas antes de confirmar.",
    assistantCancel: "Cancelar",
    assistantConfirm: "Confirmar cambio",
    assistantNoActions: "Tu rol no dispone de operaciones guiadas en esta primera versión.",
    assistantLoadError: "No se ha podido cargar el asistente.",
    assistantError: "No se ha podido responder. Puedes reintentarlo.",
    assistantProposalError: "No se ha podido preparar el cambio.",
    assistantConfirmError: "No se ha podido confirmar el cambio.",
    assistantChangeSaved: "El cambio se ha validado, guardado y registrado en auditoría.",
    assistantAction_player_create: "Crear jugador",
    assistantAction_player_update: "Actualizar jugador",
    assistantAction_family_create: "Crear familia",
    assistantAction_family_update: "Actualizar familia",
    assistantAction_player_link_family: "Relacionar jugador y familia",
    assistantAction_player_assign_team: "Asignar jugador a equipo",
    assistantAction_inscription_create: "Registrar inscripción",
    assistantAction_attendance_update: "Registrar asistencia",
    assistantAction_callup_prepare: "Preparar convocatoria",
    assistantAction_equipment_update: "Actualizar equipamiento",
    assistantField_nombre: "Nombre", assistantField_apellidos: "Apellidos",
    assistantField_fecha_nacimiento: "Fecha de nacimiento", assistantField_centro_escolar: "Centro escolar",
    assistantField_categoria: "Categoría", assistantField_equipo_id: "Equipo",
    assistantField_dorsal: "Dorsal", assistantField_posicion: "Posición",
    assistantField_estado: "Estado", assistantField_familia_id: "Familia",
    assistantField_progenitor1_nombre: "Tutor 1", assistantField_progenitor1_telefono: "Teléfono tutor 1",
    assistantField_progenitor1_email: "Correo tutor 1", assistantField_progenitor2_nombre: "Tutor 2",
    assistantField_progenitor2_telefono: "Teléfono tutor 2", assistantField_progenitor2_email: "Correo tutor 2",
    assistantField_domicilio: "Domicilio", assistantField_contacto_principal: "Contacto principal",
    assistantField_preferencia_comunicacion: "Preferencia de comunicación", assistantField_observaciones: "Observaciones",
    assistantField_tipo: "Tipo", assistantField_nueva_incorporacion: "Nueva incorporación",
    assistantField_temporada: "Temporada", assistantField_modalidad: "Modalidad",
    assistantField_equipamiento_items: "Equipaciones (separadas por comas)",
    assistantField_training_id: "Entrenamiento", assistantField_player_id: "Jugador",
    assistantField_motivo: "Motivo", assistantField_match_id: "Partido",
    assistantField_convocados: "Convocados (JSON)", assistantField_hora_quedada: "Hora de encuentro",
    assistantField_lugar_quedada: "Lugar de encuentro", assistantField_material: "Material",
    assistantField_mensaje_familias: "Instrucciones", assistantField_response_deadline: "Plazo de respuesta",
    assistantField_player_self_response_allowed: "Respuesta directa del jugador",
    assistantField_talla_camiseta: "Talla de camiseta", assistantField_talla_pantalon: "Talla de pantalón",
    assistantField_talla_chandal: "Talla de chándal", assistantField_talla_medias: "Talla de medias",
    assistantField_talla_calzado: "Talla de calzado", assistantField_equipacion_entregada: "Equipación entregada",
    assistantField_fecha_entrega_equipacion: "Fecha de entrega", assistantField_observaciones_material: "Observaciones de material",
  },
  eu: {
    appName: "Ikas-Txiki Manager",
    viewGoogleMaps: "Ikusi Google Maps-en",
    getDirections: "Nola iritsi",
    mapsPreviewHint: "Kokapenaren aurrebista; ez da gordeko formularioa gorde arte.",
    appTagline: "Oinarrizko futbola argi eta erraz kudeatzeko",
    loginTitle: "Ongi etorri berriro",
    loginSubtitle: "Sartu zure klubaren kudeaketa gunera",
    username: "Erabiltzailea",
    password: "Pasahitza",
    usernamePlaceholder: "Erabiltzaile izena",
    loginButton: "Panelera sartu",
    loggingIn: "Sarbidea egiaztatzen…",
    loginRequired: "Sartu erabiltzailea eta pasahitza.",
    loginInvalid: "Erabiltzailea edo pasahitza ez da zuzena.",
    loginNetworkError: "Ezin izan da konektatu. Egiaztatu konexioa eta saiatu berriro.",
    playerDialogDescription: "Jokalariaren baimendutako informazioa berrikusteko eta editatzeko formularioa.",
    loginTooMany: "Saiakera gehiegi. Itxaron minutu batzuk berriro saiatu aurretik.",
    capsLockOn: "Maiuskulak aktibatuta daude.",
    showPassword: "Pasahitza erakutsi",
    hidePassword: "Pasahitza ezkutatu",
    secureAccess: "Sarbide pribatu eta segurua",
    loginFeaturePlayers: "Jokalariak eta familiak",
    loginFeatureSchedule: "Partidak eta entrenamenduak",
    loginFeatureAdmin: "Ordainketak eta dokumentazioa",
    navStart: "Hasiera",
    navPeople: "Pertsonak",
    navSport: "Kirol jarduera",
    navManagement: "Administrazioa",
    navSystem: "Sistema",
    openMenu: "Nabigazioa ireki",
    closeMenu: "Nabigazioa itxi",
    mainNavigation: "Nabigazio nagusia",
    skipToContent: "Edukira joan",
    logout: "Saioa itxi",
    role_admin: "Administratzailea",
    role_admin_secondary: "Sistemaren administratzailea 2",
    role_coordinator: "Koordinatzailea",
    role_coach: "Entrenatzailea",
    role_family: "Familia",
    role_player: "Jokalaria",
    usersAndPermissions: "Erabiltzaileak eta baimenak",
    usersIntro: "Kudeatu pertsona bakoitzaren sarbidea eta datu-eremua.",
    userViews: "Kontu-ikuspegiak",
    activeAndPendingUsers: "Aktiboak eta zain",
    archivedUsers: "Artxibatuak",
    createFamilyAccesses: "Sortu familiaren sarbideak",
    familyAccessesTitle: "Familia-sarbideak", familyAccessesDescription: "Erabiltzaileak eta baimenak ataletik sinkronizatutako informazioa. Sarbideak han bakarrik sortzen dira.",
    familyParentLabel: "Gurasoa", familyConfirmEmail: "Posta hau baieztatu dut", familyGrantAccess: "Aplikaziorako sarbidea eman", familyInvitationFutureOnly: "Etorkizuneko alta prestatu besterik ez du egiten; ez ditu dauden kontuak aldatzen.",
    familyInvitationSend: "Gonbidapena bidali", familyInvitationResend: "Gonbidapena berriro bidali", familyInvitationNew: "Gonbidapen berria bidali",
    familyInvitationConfirmTitle: "Gonbidapenaren bidalketa baieztatu", familyInvitationConfirmResendTitle: "Gonbidapenaren birbidalketa baieztatu", familyInvitationConfirmDescription: "Kontu hau aktibatzeko eta pasahitza sortzeko mezu elektroniko bat bidaliko da.", familyInvitationConfirmResendDescription: "Aktibazio-esteka berri bat bidaliko da eta aurrekoa ordeztuko da.", familyInvitationRecipient: "Hartzailea:",
    familyInvitationSaveFirst: "Gorde fitxa gonbidapena bidali aurretik.", familyInvitationSaveAndContinue: "Gorde fitxa bidaltzeko", familyInvitationConfirmAndSave: "Baieztatu posta eta gorde", familyInvitationSavedContinue: "Fitxa gorde da. Orain gonbidapena bidal dezakezu.", familyInvitationEnableFirst: "Markatu sarbidea eta gorde fitxa bidali ahal izateko.", familyInvitationMissingEmail: "Gehitu baliozko posta elektroniko bat bidali ahal izateko.", familyInvitationInvalidEmail: "Posta elektronikoa ez da baliozkoa.", familyInvitationDuplicateEmail: "Posta elektronikoa familian errepikatuta dago.", familyInvitationUnconfirmedEmail: "Baieztatu posta elektronikoa fitxan bidali aurretik.", familyInvitationUnavailable: "Sarbide honek ez du gonbidapenik onartzen.", familyInvitationManagedInUsers: "Kontu hau Erabiltzaileak eta baimenak → Segurtasuna atalean kudeatzen da.",
    familyInvitationSentPending: "Gonbidapena bidali da. Kontua zain egongo da familiak pasahitza sortu arte.", familyInvitationDeliveryPrefix: "Posta", familyInvitationDeliveryPending: "zain", familyInvitationDeliveryFailed: "huts eginda", familyInvitationDeliveryUnknown: "baieztatu gabeko egoera", familyInvitationUnknownReason: "arrazoi ezezaguna", familyInvitationSent: "Gonbidapena zuzen bidali da.", familyInvitationNotSent: "Gonbidapena ez da bidali.",
    noName: "Izenik gabe", noEmail: "Posta elektronikorik gabe", viewAccount: "Kontua ikusi",
    usersPermissionsGuideTitle: "Nola kudeatu erabiltzaileak eta baimenak?",
    usersPermissionsGuideAccount: "Pertsona bakoitzak bere kontua du: erabiltzailea, posta elektronikoa eta pasahitza.",
    usersPermissionsGuideSecrets: "Ez dira pasahitzak, tokenak edo aktibazio-estekak erakusten.",
    usersPermissionsGuideStatuses: "Egoera Aktiboa, Aktibatzeko zain edo Blokeatua izan daiteke.",
    usersPermissionsGuidePending: "Aktibatzeko zain dagoen kontu batek gonbidapena osatu eta bere pasahitza sortu behar du.",
    usersPermissionsGuideManagement: "Pantaila honetatik erabiltzailea, posta elektronikoa, rola, egoera eta azken sarbidea berrikus daitezke; baita sarbidea blokeatu, editatu edo berrezarri ere, lehendik dagoen fluxu seguruaren bidez.",
    usersPermissionsGuideFamilies: "Gurasoentzat, sarbidea sortu eta nork izango duen erabakitzea Familia-fitxatik egitea gomendatzen da, “Familia-aprovisionamendua” atalean. Erabiltzaileak eta baimenak atalak lehendik sortutako kontuak berrikusi eta administratzeko balio du.",
    usersPermissionsGuideDistinctEmails: "Bereizita sartu behar duten bi gurasok bi posta elektroniko desberdin izan behar dituzte.",
    usersPermissionsGuidePlayerEmail: "Jokalari baten posta elektronikoa aldatzeak ez du konturik sortzen eta ez du gonbidapenik bidaltzen.",
    usersPermissionsGuideFlowLabel: "Erabiltzaileak eta baimenak kudeatzeko urratsak",
    usersPermissionsGuideStepOne: "Pertsona sortu edo berrikusi.",
    usersPermissionsGuideStepTwo: "Rol eta eremu egokiak esleitu.",
    usersPermissionsGuideStepThree: "Erabiltzailea, posta elektronikoa eta egoera berrikusi.",
    usersPermissionsGuideStepFour: "Gonbidapena bidali edo berriz bidali, dagokionean bakarrik.",
    usersPermissionsGuideSafetyNotice: "Ez partekatu konturik edo pasahitzik; pertsona bakoitzak bere kredentzialak erabili behar ditu.",
    users: "Erabiltzaileak",
    userDialogDescription: "Sortu edo eguneratu kontu iraunkor bat eta haren baimendutako eremua.",
    effectivePermissionsDescription: "Kontsultatu rolak baimendutako funtzioak eta haren eremuko datuak.",
    security: "Segurtasuna", accessSecurity: "Sarbide-segurtasuna",
    accessSecurityDescription: "Kudeatu sarbide sentikorrak. Ekintza bakoitza berretsi eta auditatu egiten da.",
    securityStatus: "Segurtasun-egoera", temporarilyLocked: "Aldi baterako blokeatuta",
    accessStatus: "Sarbide-egoera", currentStatus: "Uneko egoera", lastActivation: "Azken aktibazioa",
    accessState_active: "Aktiboa", accessState_pending_activation: "Aktibatzeko zain", accessState_blocked: "Blokeatuta",
    accessAvailable: "Sarbidea erabilgarri", invitation: "Gonbidapena",
    invitationStatus_none: "Gonbidapenik gabe", invitationStatus_pending: "Zain",
    invitationStatus_active: "Erabilia", invitationStatus_expired: "Iraungita",
    invitationStatus_cancelled: "Ezeztatuta", shownOnlyOnce: "Behin bakarrik erakutsiko da. Gorde orain.",
    understoodHideSecret: "Ulertuta, ezkutatu", systemSecurityReadOnly: "Kontu honen segurtasuna zerbitzarian soilik konfiguratzen da.",
    generateTemporaryPassword: "Aldi baterako pasahitza sortu", generateInvitation: "Gonbidapena posta bidez bidali",
    closeSessions: "Saioak itxi", lockAccess: "Sarbidea blokeatu", unlockAccess: "Sarbidea desblokeatu",
    deactivateAccess: "Sarbidea baja eman", confirmDeactivateAccess: "Sarbide hau desaktibatuko da, saioak itxi egingo dira eta ez da fitxarik ezabatuko. Jarraitu nahi duzu?", accessDeactivated: "Sarbideari baja zuzen eman zaio",
    permanentDeleteUser: "Erabiltzailea behin betiko ezabatu", permanentDeletionChecking: "MongoDBk ezabaketa atomikoa onartzen duen egiaztatzen…",
    confirmSensitiveAction: "Ekintza honek erabiltzailearen sarbidean eragina izango du. Jarraitu nahi duzu?",
    securityActionCompleted: "Segurtasun-ekintza osatu da", changePassword: "Pasahitza aldatu",
    passwordChangedLoginAgain: "Pasahitza eguneratu da. Hasi saioa berriro.",
    communicationDialogDescription: "Prestatu komunikazio bat eta berrikusi hartzaileak gorde aurretik.",
    resetPassword: "Pasahitza berrezarri", passwordResetRequested: "Kontua berreskuratu badaiteke, jarraibideak posta elektronikoz jasoko ditu.",
    passwordHidden: "Pasahitza ezkutatuta", emailAddress: "Posta elektronikoa", roleAndAccess: "Rola eta sarbide-egoera", accountStatusLabel: "Kontuaren egoera",
    noUsers: "Oraindik ez dago erabiltzailerik konfiguratuta.",
    noUsersFiltered: "Ez dago iragazkiekin bat datorren konturik.",
    newUser: "Erabiltzaile berria",
    createUser: "Erabiltzailea sortu",
    editUser: "Erabiltzailea editatu",
    userSaved: "Erabiltzailea behar bezala gorde da",
    saveError: "Ezin izan dira aldaketak gorde.",
    role: "Rola",
    assignedTeams: "Esleitutako taldeak",
    assignedCategories: "Esleitutako kategoriak",
    linkedPlayer: "Lotutako jokalaria",
    linkedFamily: "Lotutako familia",
    familyContactSlot: "Guraso titularra",
    familyParentOne: "1. gurasoa",
    familyAccountScopeHint: "Kontua guraso hau titular gisa eta haren seme-alaba guztiak jokalari lotu gisa sortuko da.",
    language: "Hizkuntza",
    active: "Aktiboa",
    inactive: "Inaktiboa",
    accountCounters: "Kontuen laburpena",
    pagination: "Erabiltzaileen orrikatzea",
    total: "Guztira",
    pendingActivation: "Zain",
    suspended: "Etenda",
    blocked: "Blokeatuta",
    deactivated: "Desaktibatuta",
    incompleteLink: "Lotura osatu gabe",
    accountStatus_active: "Aktiboa",
    accountStatus_pending_activation: "Aktibatzeko zain",
    accountStatus_suspended: "Etenda",
    accountStatus_deactivated: "Desaktibatuta",
    accountStatus_incomplete_link: "Lotura osatu gabe",
    searchUsers: "Bilatu izenaren, postaren edo erabiltzailearen arabera",
    firstName: "Izena",
    lastName: "Abizenak",
    confirmPassword: "Pasahitza berretsi",
    showPassword: "Pasahitza erakutsi",
    hidePassword: "Pasahitza ezkutatu",
    passwordMismatch: "Pasahitzak ez datoz bat.",
    password_length: "Gutxienez 12 karaktere",
    password_upper: "Maiuskula bat",
    password_lower: "Minuskula bat",
    password_number: "Zenbaki bat",
    password_symbol: "Ikur bat",
    systemAdministrator: "Sistemaren administratzailea",
    configuredOnServer: "Zerbitzarian konfiguratuta",
    lastAccess: "Azken sarbidea",
    never: "Inoiz ez",
    effectivePermissions: "Baimen eraginkorrak",
    viewProfile: "Fitxa ikusi", userProfile: "Administrazio-fitxa", userProfileDescription: "Kontsultatu identitatea, baimenak, loturak, jarduera eta sarbideak sekreturik erakutsi gabe.",
    identityAndAccess: "Datuak eta sarbidea", roleAndScope: "Rola eta eremua", recentActivity: "Azken jarduera", sessions: "Saioak",
    individualSessionsUnavailable: "Ez dago banakako saioen jarraipenik; saio guztiak ixtea baino ez dago erabilgarri.", notAvailable: "Ez dago erabilgarri", available: "Erabilgarri",
    linkComplete: "Lotura osatua", securityState_verified: "Egiaztatuta", securityState_locked: "Blokeatuta", securityState_password_change_required: "Pasahitza aldatzeko zain", securityState_invitation_pending: "Gonbidapena zain", securityState_invitation_expired: "Gonbidapena iraungita",
    wizardProgress: "Erabiltzailea sortzeko urratsak", userStep_1: "Identitatea", userStep_2: "Rola", userStep_3: "Eremua", userStep_4: "Sarbidea",
    phone: "Telefonoa", suggest: "Iradoki", searchTeams: "Taldeak bilatu", season: "Denboraldia", selectVisible: "Ikusgaiak hautatu", clearSelection: "Hautaketa kendu", selectedTeams: "Hautatutako taldeak", summary: "Laburpena",
    incompleteLinkWarning: "Beharrezko lotura osatu gabe dago. Kontu aktiboa ezin da horrela gorde.", accessMethod: "Sarbide-metodoa", accessPassword: "Behin betiko pasahitza", accessTemporary: "Aldi baterako pasahitza", accessInvitation: "Gonbidapena sortu (bidali gabe)", accessPending: "Zain utzi",
    roleHelp_admin: "Klub osorako administrazio-sarbidea.", roleHelp_coordinator: "Esleitutako kategoriak eta taldeak soilik kudeatzen ditu.", roleHelp_coach: "Bere taldeak soilik kudeatzen ditu.", roleHelp_family: "Lotutako seme-alabak soilik kontsultatzen ditu.", roleHelp_player: "Bere fitxa pertsonala soilik kontsultatzen du.",
    chooseUserType: "Hautatu zer erabiltzaile mota sortu nahi duzun", userType: "Erabiltzaile mota",
    bulkFamilyTitle: "Familientzako sarbideak sortu", bulkPlayerTitle: "Goi-mailako kategoriako jokalarientzako sarbideak sortu",
    familyProvisioningGuideTitle: "Nola funtzionatzen du?", familyProvisioningManualTitle: "Eskuzko modua", familyProvisioningManualDescription: "Administratzaileak sarbide bakoitza noiz sortu edo bidali erabakitzen du.", familyProvisioningDeliveryTitle: "Bidalketa teknikoa desgaituta", familyProvisioningDeliveryDescription: "Ez da mezu elektronikorik nahi gabe bidaliko.", familyProvisioningAutomaticTitle: "Automatikoa aktibatu", familyProvisioningAutomaticDescription: "Bi guraso posta elektroniko desberdin eta baliozkoekin hautematen direnean sarbideak prestatzeko aukera ematen du. Ez aktibatu hainbat familiekin probak amaitu arte.", familyProvisioningPreflightTitle: "Preflight-a sortu", familyProvisioningPreflightDescription: "Familiak berrikusten ditu eta prest dauden kasuak, posta errepikatuak, posta faltak eta lehendik dauden sarbideak erakusten ditu. Ez du konturik sortzen, ez du daturik aldatzen eta ez du mezurik bidaltzen.", familyProvisioningFlowLabel: "Familia-aprovisionamendurako gomendatutako urratsak", familyProvisioningStepOne: "Preflight-a exekutatu.", familyProvisioningStepTwo: "Posta elektronikoak berrikusi eta zuzendu.", familyProvisioningStepThree: "2 edo 3 familiekin probatu.", familyProvisioningStepFour: "Modu automatikoa probak balioztatu ondoren bakarrik aktibatu.", familyProvisioningSafetyNotice: "Guraso bakoitzak bere posta elektronikoa behar du sarbide independentea izateko. Ez dira inoiz pasahitzak, tokenak, aktibazio-estekak edo datu sentikorrak erakusten.", familyProvisioningUsersPermissionsTitle: "Erabiltzaileak eta baimenak atalarekin duen lotura", familyProvisioningParentOne: "1. gurasoa: Familia kontua", familyProvisioningFamilyRecord: "Familia-fitxa bera", familyProvisioningParentTwo: "2. gurasoa: Familia kontua", familyProvisioningUsersPermissionsDescription: "1. gurasoarentzat edo 2. gurasoarentzat sortutako sarbide bakoitzak Familia rola duen kontu independente bat sortu edo lotzen du Erabiltzaileak eta baimenak atalean, familia berari lotuta.", familyProvisioningSharedFamily: "Bi gurasoek familia bera eta haren seme-alabak ikus ditzakete.", familyProvisioningSeparateCredentials: "Bakoitza bere erabiltzaile eta pasahitzarekin sartzen da.", familyProvisioningUsersPermissionsManagement: "Erabiltzaileak eta baimenak atalak egoera berrikusteko, sarbidea blokeatzeko edo berrezartzeko balio du.", familyProvisioningFamilyRecordDecision: "Familia-fitxa da zein gurasok jasoko duen sarbidea erabakitzeko tokia.", familyProvisioningPlayerEmailNotice: "Jokalariaren fitxako posta elektronikoa aldatzeak ez du gonbidapenik sortzen edo bidaltzen.", familyProvisioningDistinctEmails: "Bi sarbide independente izateko, bi posta elektroniko desberdin behar dira.",
    bulkAccessIntro: "Hautatu bat, batzuk edo guztiak. Ez da konturik sortuko eta ez da mezurik bidaliko azken baieztapenera arte.",
    searchNameEmail: "Bilatu izenaren edo posta elektronikoaren arabera", selectAllAvailable: "Hautatu erabilgarri guztiak",
    readyToInvite: "Gonbidatzeko prest", invitationPending: "Gonbidapena zain", invitationExpired: "Gonbidapena iraungita",
    activeAccount: "Kontu aktiboa", missingValidEmail: "Baliozko posta elektronikorik gabe", loadingCandidates: "Kargatzen…",
    candidatesLoadError: "Ezin izan dira hautagaiak kargatu", accountsCreateError: "Ezin izan dira kontuak sortu",
    finalConfirmation: "Azken baieztapena", bulkConfirmationDetail: "{count} kontu sortu edo berrituko dira eta gonbidapenak posta elektronikoz bidaliko dira.",
    reviewSelection: "Hautapena berrikusi", confirmCreateSend: "Baieztatu, sortu eta bidali", processCompleted: "Prozesua amaituta",
    invitationsResult: "{sent} gonbidapen bidalita. {remaining} erregistro baztertuta edo zain.", playersCount: "{count} jokalari",
    roleDefinesFunctionsScopeDefinesData: "Rolak funtzioak zehazten ditu; eremuak zein datutan erabil daitezkeen.",
    allowedFunctions: "Baimendutako funtzioak",
    appliedScope: "Aplikatutako eremua",
    recipientPreview: "Hartzaileen aurrebista",
    recipientPreviewHelp: "Kontuak eta erlazioak kalkulatzen ditu komunikazioa bidali gabe.",
    recipientPreviewError: "Ezin izan dira hartzaileak kalkulatu.",
    unresolvedRecipient: "Uneko erlaziorik gabeko hartzaile historikoa",
    activeAccounts: "Kontu aktiboak",
    availableEmails: "Posta erabilgarriak",
    excludedRecipients: "Baztertutako hartzaileak",
    preview: "Aurrebista",
    send: "Bidali",
    sending: "Bidaltzen…",
    confirmSendCommunication: "Komunikazio hau honako hartzaileei bidaliko zaie:",
    recipients: "hartzaile. Jarraitu nahi duzu?",
    communicationSent: "Komunikazioa bidali da.",
    communicationSendError: "Ezin izan da komunikazioa bidali.",
    communicationAlreadySent: "Komunikazioa dagoeneko bidaltzen ari da edo bidali da.",
    communicationGuideTitle: "Nola sortu eta bidali komunikazio bat",
    communicationGuideCollapsed: "Sortzeko, berrikusteko eta bidaltzeko gida praktikoa.",
    communicationGuideIntro: "Komunikazioak lehenik zain gisa gordetzen dira. Bidali aurretik, aplikazioak hartzaileek harremanetarako datu balioduna eta jakinarazpenak jasotzeko baimena dituztela egiaztatzen du.",
    viewGuide: "Ikusi gida", hideGuide: "Ezkutatu gida", reviewAuthorizations: "Baimenak berrikusi",
    communicationGuideStepAuthorizations: "Egiaztatu baimenak",
    communicationGuideStepAuthorizationsText: "Jokalariak edo haren familiak email balioduna eta Posta elektronikoa kanala baimenduta izan behar ditu. Baimenak atalean berrikus dezakezu.",
    communicationGuideStepCreate: "Sortu komunikazioa",
    communicationGuideStepCreateText: "Sakatu Gehitu, idatzi izenburua eta mezua, eta hautatu erabilgarri dauden hartzaileak. Taldea, kategoria edo jokalaria aukeratu ditzakezu, baita kanala eta lehentasuna ere.",
    communicationGuideStepSave: "Gorde eta berrikusi", communicationGuideStepSaveText: "Sortzean, Zain egoeran geratuko da. Une honetan oraindik ez da mezurik bidali.",
    communicationGuideStepPreview: "Aurreikusi bidalketa", communicationGuideStepPreviewText: "Sakatu Bidali erabilgarri dauden kontaktuak eta baimenik ezagatik baztertutakoak zenbat diren egiaztatzeko.",
    communicationGuideStepConfirm: "Berretsi", communicationGuideStepConfirmText: "Berrikusi laburpena eta berretsi bidalketa. Aplikazioak baieztatutako komunikazio bat bi aldiz bidaltzea eragotziko du.",
    communicationStatesTitle: "Komunikazioaren egoerak",
    communicationStatePendingText: "Sortuta dago, baina oraindik ez da bidali.", communicationStateSendingText: "Hornitzailea bidalketa prozesatzen ari da. Ez errepikatu ekintza.", communicationStateSentText: "Hornitzaileak entrega berretsi du.", communicationStateFailedText: "Ezin izan da bidalketa berretsi. Berriro saiatu aurretik, berrikusi arrazoia.",
    communicationFailureHelpTitle: "Zergatik huts egin du?",
    communicationFailureAuthorizationText: "Ez dago bidalketa honetarako baimendutako kontakturik. Egiaztatu jokalariak edo familiak email balioduna eta Posta elektronikoa kanala baimenduta dituela.",
    communicationFailureNextStep: "Baimena zuzendu ondoren, itzuli hona eta sakatu Bidali aurrebista berri bat sortzeko.",
    permissionAction_read: "Ikusi", permissionAction_create: "Sortu", permissionAction_edit: "Editatu",
    permissionAction_delete: "Baliogabetu edo ezabatu", permissionAction_export: "Esportatu",
    permissionAction_administer: "Administratu", permissionAction_respond: "Erantzun",
    permissionAction_submit: "Dokumentuak jaso",
    permissionResource_dashboard: "Panel nagusia", permissionResource_users: "Erabiltzaileak",
    permissionResource_players: "Jokalariak", permissionResource_families: "Familiak",
    permissionResource_teams: "Taldeak", permissionResource_trainings: "Entrenamenduak",
    permissionResource_matches: "Partidak", permissionResource_callups: "Deialdiak",
    permissionResource_attendance: "Asistentzia", permissionResource_payments: "Kuotak eta ordainketak",
    permissionResource_authorizations: "Baimenak", permissionResource_inscriptions: "Izen-emateak",
    permissionResource_communications: "Komunikazioak", permissionResource_reports: "Txostenak",
    permissionResource_stats: "Estatistikak", permissionResource_search: "Bilatzailea",
    permissionResource_equipment: "Ekipamendua", permissionResource_settings: "Konfigurazioa",
    permissionResource_modalities: "Modalitateak", permissionResource_data: "Datuen administrazioa",
    permissionResource_calendar: "Egutegia", permissionResource_portal: "Ataria",
    permissionResource_notifications: "Jakinarazpenak", permissionResource_assistant: "Laguntzailea",
    permissionResource_training_evaluations: "Entrenamendu-ebaluazioak",
    permissionResource_training_library: "Entrenamenduen liburutegia",
    permissionResource_match_reports: "Partiden aktak eta errendimendua",
    more: "Gehiago",
    loading: "Kargatzen…",
    retry: "Saiatu berriro",
    previous: "Aurrekoa",
    next: "Hurrengoa",
    loadError: "Ezin izan dugu informazioa kargatu.",
    connectionHint: "Egiaztatu konexioa eta saiatu berriro.",
    dashboardWelcome: "Zure klub osoa, begirada batean",
    dashboardIntro: "Berrikusi garrantzitsuena eta jarraitu utzi zenuen lekutik.",
    overview: "Laburpena",
    needsAttention: "Arreta behar du",
    schedule: "Hurrengo agenda",
    privacyTitle: "Pribatutasuna eta datuak",
    privacyBody: "Saioa seguru mantentzeko beharrezkoa den cookiea bakarrik erabiltzen dugu. Ez dugu publizitate edo jarraipen cookierik erabiltzen.",
    understood: "Ulertuta",
    dismiss: "Oharra itxi",
    splashBadge: "Kirol kudeaketa adimenduna",
    splashDescription: "Jokalariak, familiak eta lehiaketa gune bakarrean.",
    enter: "Sartu",
    dashboard: "Panel nagusia",
    calendar: "Egutegia",
    calendarFilters: "Egutegiaren iragazkiak",
    calendarView: "Egutegiaren ikuspegia",
    calendarView_month: "Hilabetea",
    calendarView_week: "Astea",
    calendarView_agenda: "Agenda",
    calendarType_match: "Partida",
    calendarType_training: "Entrenamendua",
    calendarType_meeting: "Bilera",
    calendarType_club_event: "Klubeko ekitaldia",
    eventType: "Ekitaldi mota",
    newCalendarEvent: "Ekitaldi berria",
    editCalendarEvent: "Ekitaldia editatu",
    calendarLoadError: "Ezin izan da egutegia kargatu.",
    calendarSaveError: "Ezin izan da ekitaldia gorde.",
    calendarExportError: "Ezin izan da egutegia esportatu.",
    noCalendarEvents: "Ez dago jarduerarik aldi honetan.",
    previousPeriod: "Aurreko aldia",
    nextPeriod: "Hurrengo aldia",
    today: "Gaur",
    wholeClub: "Klub osoa",
    addGoogleCalendar: "Google Calendar-era gehitu",
    calendarDetailDescription: "Hautatutako kirol-ekitaldiaren informazioa.",
    calendarEditorDescription: "Bete bileraren edo klubeko ekitaldiaren datuak.",
    familyPlayerPortal: "Nire gunea",
    familyPortal: "Familia-ataria",
    playerPortal: "Jokalariaren ataria",
    portalSubtitle: "Kirol-informazioa, deialdiak eta dokumentuak gune seguru bakarrean.",
    selectChild: "Hautatu seme-alaba",
    sportProfile: "Kirol-profila",
    noTeam: "Ez dago talderik esleituta",
    attendancePercentage: "Asistentzia-ehunekoa",
    noAttendanceRecords: "Oraindik ez dago asistentzia-erregistrorik.",
    noPendingPayments: "Ez dago ordainketarik zain.",
    documentsAndAuthorizations: "Dokumentuak eta baimenak",
    documentationStatus: "Dokumentazioaren egoera",
    signedPdf: "Deskargatu sinatutako dokumentua",
    familyAuthOnboardingEyebrow: "Familiaren dokumentazioa",
    familyAuthOnboardingTitle: "Osatu zure seme-alaben baimenak",
    familyAuthOnboardingIntro: "Deskargatu baimen bakoitza, sinatu paperean eta igo, edo erabili aplikazioko sinadura erraza. Ataria erabiltzen jarrai dezakezu dokumenturen bat falta bada ere.",
    familyAuthProgress: "Baimenen aurrerapena",
    familyAuthPending: "Jaso gabe dago",
    familyAuthComplete: "Dokumentua jasota",
    familyAuthPendingNotice: "Osatzeko baimenak daude zain.",
    familyAuthBannerDetail: "Zain:",
    familyAuthChildren: "Baimenak dituzten seme-alabak",
    familyAuthDownload: "Baimena deskargatu",
    familyAuthUpload: "Sinatutako dokumentua igo",
    familyAuthSignElectronically: "Aplikazioan sinatu",
    familyAuthSignTitle: "Sinadura erraza aplikazioan",
    familyAuthSignHelp: "Marraztu zure sinadura eta berretsi baimena.",
    familyAuthSignerName: "Sinatzen duen pertsonaren izena",
    familyAuthParentLabel: "Baimenean agertzen den gurasoa",
    familyAuthParentPlaceholder: "Hautatu guraso bat",
    familyAuthParentCurrent: "Konektatutako kontua",
    familyAuthParentCurrentNotice: "Konektatutako kontua baimena eman duen kontu gisa erregistratuko da.",
    familyAuthParentPaperNotice: "Guraso hau baimenean agertuko da. Konektatutako kontua dokumentua eman duen kontu gisa erregistratuko da.",
    familyAuthElectronicCurrentOnly: "Elektronikoki sinatzeko, hautatutako gurasoaren kontuarekin hasi behar duzu saioa.",
    familyAuthParentRequired: "Hautatu baimenean agertzen den gurasoa.",
    familyAuthParentUnavailable: "Ezin izan dira familia honetako gurasoak kargatu.",
    familyAuthSignerRequired: "Idatzi sinatzen duen pertsonaren izena.",
    familyAuthDrawSignature: "Marraztu zure sinadura",
    familyAuthClearSignature: "Sinadura ezabatu",
    familyAuthSignatureArea: "Sinadura marrazteko eremua",
    familyAuthConsent: "Baimen hau irakurri dudala eta sinadura erraz hau erregistratzeko berariazko baimena ematen dudala berresten dut.",
    familyAuthConsentRequired: "Sinatu aurretik baimena berretsi behar duzu.",
    familyAuthLegalNotice: "Sinadura elektroniko erraza da, eta ez da sinadura kualifikatu edo ziurtatu gisa aurkezten.",
    familyAuthSaveSignature: "Sinadura gorde",
    familyAuthNoSignature: "Marraztu zure sinadura jarraitu aurretik.",
    familyAuthReceived: "Dokumentua behar bezala jaso da.",
    familyAuthUploadError: "Ezin izan da dokumentua jaso. Egiaztatu formatua eta tamaina.",
    familyAuthSignatureError: "Ezin izan da sinadura gorde.",
    familyAuthInvalidType: "PDF, JPG, PNG edo WEBP fitxategiak baino ez dira onartzen.",
    familyAuthInvalidFile: "Fitxategiak ez du baliozko formaturik.",
    familyAuthFileTooLarge: "Fitxategiak onartutako gehieneko tamaina gainditzen du.",
    familyAuthPermissionError: "Ez duzu baimen hau bidaltzeko baimenik.",
    familyAuthOpen: "Baimenak berrikusi",
    familyAuthLater: "Geroago egin",
    familyAuthSimpleNotice: "Dokumentua jasotzeak ez du oraindik administrazio-balidaziorik esan nahi.",
    familyPendingResendTitle: "Familia-gonbidapenak zain",
    familyPendingResendDescription: "Berritu eta prozesatu oraindik zain dauden familia-kontu guztien gonbidapenak.",
    familyPendingResendButton: "Zain daudenak birbidali",
    familyPendingResendResult: "Emaitza (bidalita · zain · huts eginda):",
    familyPendingResendError: "Ezin izan dira zain dauden gonbidapenak birbidali.",
    authorizationReceivedAt: "Jasotzea",
    authorizationMode: "Modalitatea",
    authorizationReceivedBy: "Nork jasoa",
    authorizationModeUpload: "Fitxategia",
    authorizationModeElectronic: "Sinadura erraza",
    authorizationSignerParent: "Baimenean agertzen den gurasoa",
    authorizationSignerParentPlaceholder: "Hautatu guraso bat",
    authorizationSignerParentHint: "Izena familiaren fitxatik hartzen da eta zerbitzarian baliozkotzen da.",
    saving: "Gordetzen…",
    communication: "Komunikazioa",
    portalLoadError: "Ezin izan da zure gune pertsonala kargatu.",
    portalNoAssociation: "Zure erabiltzaileak oraindik ez du jokalari edo familiarik lotuta.",
    noUpcomingActivities: "Ez dago hurrengo jarduerarik.",
    confirmCallupQuestion: "Asistentzia baieztatu nahi duzu?",
    declineCallupQuestion: "Deialdia ukatu nahi duzu?",
    playerResponseNotAllowed: "Zuzeneko erantzuna zure familiak egin behar du.",
    noCallups: "Ez dago deialdirik erabilgarri.",
    downloadError: "Ezin izan da dokumentua deskargatu.",
    authType_general: "Parte hartzeko baimen orokorra",
    authType_imagen: "Irudia erabiltzeko baimena",
    authType_medica: "Oinarrizko mediku-baimena",
    authType_desplazamientos: "Lekualdaketa baimena",
    authType_recogida: "Hirugarrenek jasotzeko baimena",
    authType_proteccion_datos: "Datuen babesa",
    notifications: "Jakinarazpenak",
    notificationCenterDescription: "Jakinarazpen pertsonalak eta jakinarazpen-hobespenak.",
    close: "Itxi",
    markAllRead: "Markatu dena irakurrita",
    notificationsLoadError: "Ezin izan dira jakinarazpenak kargatu.",
    noNotifications: "Ez duzu jakinarazpenik.",
    notificationPreferences: "Jakinarazpen-hobespenak",
    notificationPref_in_app: "Aplikazio barruko jakinarazpenak",
    notificationPref_email: "Posta elektronikoa",
    notificationPref_telegram: "Telegram",
    notificationPref_callups: "Deialdiak",
    notificationPref_schedule_changes: "Ordutegiak eta jarduerak",
    notificationPref_payments: "Ordainketak",
    notificationPref_documents: "Dokumentuak eta baimenak",
    providerEmail: "Posta-hornitzailea",
    providerTelegram: "Telegram bota",
    configured: "Konfiguratuta",
    notConfigured: "Konfiguratu gabe",
    configuredOptional: "Konfiguratuta, aktibatzeko zain",
    failed: "Huts eginda",
    deliveryPending: "Zain",
    priority: "Lehentasuna",
    priority_low: "Txikia",
    priority_normal: "Normala",
    priority_high: "Handia",
    priority_urgent: "Premiazkoa",
    providerNotConfiguredPending: "Hornitzailea ez dago konfiguratuta. Bidalketa zain erregistratuko da.",
    allDay: "Egun osoa",
    title: "Izenburua",
    description: "Deskribapena",
    location: "Lekua",
    endDate: "Amaiera-data",
    endTime: "Amaiera-ordua",
    players: "Jokalariak",
    families: "Familiak",
    teams: "Taldeak",
    matches: "Partidak",
    callups: "Deialdiak",
    payments: "Kuotak eta ordainketak",
    authorizations: "Baimenak",
    settings: "Konfigurazioa",
    globalSearch: "Bilatu dena",
    globalSearchPlaceholder: "Bilatu jokalaria, taldea, partida, familia…",
    searchNoResults: "Emaitzarik ez",
    globalSearchError: "Ezin izan da bilaketa egin. Saiatu berriro.",
    searchTypeToStart: "Idatzi eskola osoan bilatzeko",
    resType_player: "Jokalariak",
    resType_team: "Taldeak",
    resType_match: "Partidak",
    resType_family: "Familiak",
    resType_inscription: "Izen-emateak",
    resType_payment: "Ordainketak",
    inscriptions: "Izen-emateak",
    trainings: "Entrenamenduak",
    stats: "Estatistikak",
    integralStats: "Estatistika integralak",
    integralStatsSubtitle: "Erregistratutako kirol-datuetatik kalkulatutako adierazleak.",
    statisticsFilters: "Estatistika-iragazkiak",
    statisticsOverview: "Laburpen orokorra",
    statisticsAttendance: "Asistentzia eta entrenamenduak",
    statisticsMatches: "Partidak eta emaitzak",
    statisticsCallups: "Deialdiak",
    activePlayers: "Jokalari aktiboak",
    scheduledMatches: "Programatutako partidak",
    playedMatches: "Jokatutako partidak",
    scheduledTrainings: "Programatutako entrenamenduak",
    completedTrainings: "Egindako entrenamenduak",
    registeredResults: "Erregistratutako emaitzak",
    wins: "Garaipenak",
    draws: "Berdinketak",
    losses: "Porrotak",
    goalsFor: "Aldeko golak",
    goalsAgainst: "Kontrako golak",
    sessionsComputable: "Kalkulagarri diren saioak",
    sessionsPending: "Zain dauden saioak",
    attendanceRecords: "Asistentzia-erregistroak",
    attendancePercentage: "Asistentzia-ehunekoa",
    callupsConfirmed: "Baieztatuak",
    callupsDeclined: "Baztertuak",
    callupsPending: "Zain",
    evolution: "Bilakaera",
    byTeam: "Taldekako banaketa",
    byPlayer: "Jokalarien banaketa",
    noStatisticsData: "Ez dago adierazle hau erakusteko behar adina datu.",
    noTrainingData: "Ez dago entrenamendurik hautatutako aldian.",
    noCallupData: "Ez dago adierazle hau kalkulatzeko behar adina deialdirik.",
    noMatchResult: "Partidak ez du emaitzarik erregistratuta.",
    incompleteStatistics: "Datu osatugabeak daude; ezezagunak ez dira zero gisa zenbatzen.",
    derivedStatisticsNotice: "Metrikak zerbitzarian kalkulatzen dira eta ez dira guztizko gisa gordetzen.",
    manualStatsLegacy: "Eskuzko erregistro historikoak",
    manualStatsCount: "Eskuzko erregistroak",
    statisticsExportPdf: "PDFa esportatu",
    statisticsExportExcel: "Excela esportatu",
    exportUser: "Sortzailearen erabiltzailea",
    allStatuses: "Egoera guztiak",
    activeOnly: "Aktiboak bakarrik",
    inactiveOnly: "Inaktiboak bakarrik",
    allPlayers: "Jokalari guztiak",
    allModalities: "Modalitate guztiak",
    clearFilters: "Iragazkiak garbitu",
    statisticsLoadError: "Ezin izan dira estatistikak kargatu.",
    statisticsExportError: "Ezin izan da esportazioa sortu.",
    statisticsAccessDenied: "Estatistika internoak ez daude profil honentzat erabilgarri.",
    communications: "Komunikazioa",
    reports: "Txostenak",
    modality: "Modalitatea",
    professionalReports: "Txosten profesionalak",
    professionalReportsHelp: "Kontsultatu baimendutako kirol-datuak zerbitzarian kalkulatutako iragazki eta guztizkoekin.",
    professionalReportsLoadError: "Ezin izan da txostenen katalogoa kargatu.",
    professionalReportsPreviewError: "Ezin izan da aurrebista sortu.",
    professionalReportCatalog: "Txostenen katalogoa",
    reportFilters: "Txostenaren iragazkiak",
    reportDateFrom: "Hasiera-data",
    reportDateTo: "Amaiera-data",
    reportPeriod: "Aldia",
    reportWeekly: "Astekoa",
    reportMonthly: "Hilekoa",
    reportGroupBy: "Taldekatu honen arabera",
    reportByPlayer: "Jokalaria",
    reportByTeam: "Taldea",
    appliedFilters: "Aplikatutako iragazkiak",
    previewReport: "Ikusi aurrebista",
    legacyReports: "Aurreko txostenak",
    professionalExports: "Esportazio profesionalak",
    downloadProfessionalPDF: "PDFa deskargatu",
    downloadProfessionalExcel: "Excela deskargatu",
    preparingExport: "Prestatzen…",
    professionalExportPreparing: "Fitxategia prestatzen ari da.",
    professionalExportNoResults: "Ez dago esportatzeko emaitzarik.",
    professionalExportError: "Ezin izan da fitxategia sortu.",
    professionalExportLimitError: "Txostenak esportazioaren gehieneko muga gainditzen du.",
    reportFilter_season: "Denboraldia",
    reportFilter_category: "Kategoria",
    reportFilter_team_id: "Taldea",
    reportFilter_modality: "Modalitatea",
    reportFilter_status: "Egoera",
    reportFilter_search: "Bilaketa",
    reportFilter_date_from: "Noiztik",
    reportFilter_date_to: "Noiz arte",
    reportFilter_player_id: "Jokalaria",
    reportFilter_period: "Aldia",
    reportFilter_group_by: "Taldekatzea",
    reportColumn_name: "Izena",
    reportColumn_surname: "Abizenak",
    reportColumn_team: "Taldea",
    reportColumn_category: "Kategoria",
    reportColumn_modality: "Modalitatea",
    reportColumn_number: "Dortsala",
    reportColumn_status: "Egoera",
    reportColumn_sessions: "Saioak",
    reportColumn_present: "Bertaratzeak",
    reportColumn_justified: "Justifikatuak",
    reportColumn_unjustified: "Justifikatu gabeak",
    reportColumn_injury: "Lesioak",
    reportColumn_percentage: "Asistentzia",
    reportColumn_birth_date: "Jaioteguna",
    reportColumn_position: "Posizioa",
    reportColumn_license: "Lizentzia",
    reportColumn_joined_at: "Alta-data",
    reportColumn_date: "Data",
    reportColumn_time: "Ordua",
    reportColumn_location: "Lekua",
    reportColumn_attendees: "Bertaratuak",
    reportColumn_period_label: "Aldia",
    reportColumn_opponent: "Aurkaria",
    reportColumn_condition: "Baldintza",
    reportColumn_competition: "Lehiaketa",
    reportColumn_score: "Emaitza",
    reportColumn_response: "Erantzuna",
    reportColumn_responded_at: "Erantzun-data",
    reportColumn_late: "Epez kanpo",
    reportColumn_attendance_status: "Benetako asistentzia",
    reportColumn_consistent: "Koherentzia",
    reportColumn_capacity: "Edukiera",
    reportColumn_occupancy: "Okupazioa",
    reportColumn_type: "Mota",
    reportColumn_season: "Denboraldia",
    reportColumn_movement: "Mugimendua",
    reportColumn_document_status: "Dokumentuen egoera",
    reportColumn_missing_documents: "Falta diren dokumentuak",
    reportColumn_authorization_type: "Baimen mota",
    reportColumn_signed_at: "Sinadura-data",
    reportColumn_expires_at: "Iraungitzea",
    reportColumn_missing_count: "Falta diren eremuak",
    reportColumn_missing_fields: "Falta diren datuak",
    reportColumn_equipment_item: "Ekipamendua",
    reportColumn_shirt_size: "Kamiseta-taila",
    reportColumn_shorts_size: "Praka-taila",
    reportColumn_tracksuit_size: "Txandal-taila",
    reportColumn_delivered: "Entregatuta",
    reportColumn_delivery_date: "Entrega-data",
    reportColumn_contact_name: "Kontaktua",
    reportColumn_phone: "Telefonoa",
    reportColumn_email: "Posta elektronikoa",
    reportColumn_matches_called: "Deialdiak",
    reportColumn_matches_played: "Jokatutako partidak",
    reportColumn_minutes: "Minutuak",
    reportColumn_goals: "Golak",
    reportColumn_assists: "Asistentziak",
    reportColumn_yellow_cards: "Txartel horiak",
    reportColumn_red_cards: "Txartel gorriak",
    reportColumn_rating: "Balorazioa",
    reportColumn_concept: "Kontzeptua",
    reportColumn_expected: "Aurreikusita",
    reportColumn_paid: "Kobratuta",
    reportColumn_pending: "Zain",
    reportColumn_payment_method: "Ordainketa modua",
    reportColumn_payment_date: "Ordainketa-data",
    reportColumn_account_holder: "Kontu titularra",
    reportFilter_type: "Mota",
    reportFilter_movement: "Mugimendua",
    reportFilter_delivery: "Entrega",
    reportFilter_contact_type: "Kontaktu mota",
    reportFilter_payment_method: "Ordainketa modua",
    reportValue_alta: "Alta",
    reportValue_baja: "Baja",
    reportValue_renovacion: "Berritzea",
    reportValue_delivered: "Entregatuta",
    reportValue_pending: "Zain",
    reportValue_phone: "Telefonoa",
    reportValue_email: "Posta elektronikoa",
    reportValue_domiciliacion: "Helbideratzea",
    reportValue_transferencia: "Transferentzia",
    reportValue_efectivo: "Eskudirua",
    reportValue_bizum: "Bizum",
    reportValue_general: "Orokorra",
    reportValue_imagen: "Irudia",
    reportValue_medica: "Medikoa",
    reportValue_desplazamientos: "Lekualdaketak",
    reportValue_recogida: "Jasotzea",
    reportValue_proteccion_datos: "Datuen babesa",
    reportTotal_players: "Jokalariak",
    reportTotal_teams: "Taldeak",
    reportTotal_groups: "Taldekatzeak",
    reportTotal_sessions: "Erregistroak",
    reportTotal_present: "Bertaratzeak",
    reportTotal_justified: "Justifikatuak",
    reportTotal_unjustified: "Justifikatu gabeak",
    reportTotal_injury: "Lesioak",
    reportTotal_percentage: "Asistentzia (%)",
    reportTotal_rows: "Erregistroak",
    reportTotal_items: "Artikuluak",
    reportTotal_delivered: "Entregatuak",
    reportTotal_expected: "Aurreikusita",
    reportTotal_paid: "Kobratuta",
    reportTotal_pending: "Zain",
    equipment: "Ekipamendua",
    equipmentExport: "CSV esportatu",
    equipmentTotalPlayers: "Jokalariak guztira",
    equipmentDelivered: "Ekipamendua entregatuta",
    equipmentPending: "Entregatzeko zain",
    equipmentMissingSize: "Tailarik erregistratu gabe",
    equipmentAllTeams: "Talde guztiak",
    equipmentAllDeliveries: "Entrega guztiak",
    equipmentPlayerCount: "jokalari",
    equipmentPlayer: "Jokalaria",
    equipmentTeam: "Taldea",
    equipmentBib: "Dortsala",
    equipmentShirtName: "Kamisetaren izena",
    equipmentShirt: "Kamiseta",
    equipmentShorts: "Prakak",
    equipmentTracksuit: "Txandala",
    equipmentSocks: "Galtzerdiak",
    equipmentShoes: "Oinetakoak",
    equipmentSecondKit: "Bigarren ekipazioa",
    equipmentSecondKitShort: "2.",
    equipmentSecondKitName: "Izena",
    equipmentSecondKitBib: "Dortsala",
    equipmentSecondKitShirt: "Kamiseta",
    equipmentSecondKitSocks: "Galtzerdiak",
    equipmentDeliveryDate: "Entrega-data",
    equipmentNotes: "Oharrak",
    equipmentActions: "Ekintzak",
    equipmentNoResults: "Ez dago hautatutako iragazkiekin bat datorren jokalaririk",
    equipmentUpdated: "Ekipamendua eguneratu da",
    equipmentSaveError: "Ezin izan da gorde",
    equipmentEditHint: "Editatu ekipamendua editatzeko botoiarekin. Aldaketak jokalariaren fitxan gordeko dira.",
    equipmentNoTeam: "Talderik gabe",
    equipmentKitOverview: "Ekipamenduaren egoera",
    equipmentItemsReady: "elementu osatuta",
    equipmentMissingItems: "zain",
    equipmentComplete: "Dena prest",
    equipmentAvailable: "Eskuragarri",
    equipmentCardsView: "Txartelak",
    equipmentTableView: "Taula",
    equipmentSearchPlaceholder: "Bilatu izenaren, abizenen edo taldearen arabera",
    equipmentAllSeasons: "Denboraldi guztiak",
    equipmentOnlyMissingSizes: "Neurriak falta dituztenak bakarrik",
    equipmentViewMode: "Ikuspegi mota",
    equipmentFiltersActive: "Iragazki aktiboak",
    equipmentOverviewTitle: "Ekipamendua, begirada batean",
    equipmentOverviewDescription: "Kontsultatu entregen aurrerapena eta ikusi azkar talde bakoitzean zer falta den.",
    equipmentVisibleSuffix: "ikusgai",
    equipmentPendingHint: "Entregatzeko zain",
    equipmentMissingSizeHint: "Neurriren bat falta duten jokalariak",
    equipmentTeamsSummary: "Taldeen egoera",
    equipmentTeamsSummaryDescription: "Hautatu talde bat jokalariak eta falta diren datuak berrikusteko.",
    equipmentTeamPlayers: "jokalari",
    equipmentDeliveryProgress: "entrega-aurrerapena",
    equipmentMetadataWarning: "Ezin izan da denboraldien katalogo osoa kargatu.",
    equipmentTableHint: "Erregistro asko berrikusi eta esportatzeko ikuspegi trinkoa.",
    equipmentSeasonNotice: "Aldaketak hautatutako denboraldian gordeko dira",
    equipmentMainKit: "Lehen ekipazioa",
    equipmentDelivery: "Ekipazioaren entrega",
    equipmentSecondKitReadOnly: "Bigarren ekipazioa jokalariaren fitxatik kontsultatzen da.",
    delivered: "Entregatuta",
    pendingDelivery: "Zain",
    yes: "Bai",
    no: "Ez",
    upcomingTrainings: "Hurrengo entrenamenduak",
    noUpcomingTrainings: "Ez dago hurrengo entrenamendurik.",
    inscriptionType: "Mota",
    alta: "Alta berria",
    renovacion: "Berritzea",
    review: "Berrikusi",
    createPlayerFromInscription: "Jokalari fitxa sortu",
    possibleSibling: "Anai-arreba posiblea",
    inscriptionStatus: "Izen-emate egoera",
    convertedPlayer: "Fitxa sortuta",
    attendance: "Asistentzia",
    present: "Bertan",
    justified: "Justifikatutako hutsa",
    unjustified: "Justifikatu gabeko hutsa",
    injury: "Lesioa",
    exercises: "Landutako ariketak",
    coachNotes: "Entrenatzailearen oharrak",
    trainingEvaluations: "Banakako ebaluazioak",
    openTrainingEvaluations: "Jokalariak ebaluatu",
    evaluationSummary: "Ebaluazioen laburpena",
    evaluationEvaluated: "Ebaluatuak",
    evaluationPending: "Zain",
    evaluationIncomplete: "Osatu gabeak",
    evaluationAbsent: "Absentziak",
    evaluationFilter: "Jokalariak iragazi",
    evaluationFilterAll: "Jokalari guztiak",
    evaluationFilterEvaluated: "Ebaluatuak",
    evaluationFilterPending: "Zain",
    evaluationFilterAbsent: "Absentziak",
    evaluationFilterIncomplete: "Osatu gabeak",
    evaluationAttendance: "Erregistratutako asistentzia",
    evaluationParticipation: "Parte-hartzea",
    evaluationAttitude: "Jarrera",
    evaluationEffort: "Ahalegina",
    evaluationTacticalUnderstanding: "Ulermen taktikoa",
    evaluationTechnique: "Teknika",
    evaluationFitness: "Prestaketa fisikoa",
    evaluationObservations: "Barne-oharrak",
    evaluationIncidents: "Barne-intzidentziak",
    evaluationScale: "1–5 eskala; ez da neurketa klinikoa",
    evaluationNoScoresAbsent: "Puntuaziorik ez: jokalaria ez da bertan izan",
    evaluationDraft: "Zirriborroa",
    evaluationCompleted: "Osatua",
    evaluationClosed: "Itxita",
    evaluationSave: "Ebaluazioa gorde",
    evaluationSaveAll: "Aldaketak gorde",
    evaluationClose: "Ebaluazioa itxi",
    evaluationCloseConfirm: "Ebaluazio hau itxi? Ondoren ezin izango da editatu.",
    evaluationHistory: "Jokalariaren historia",
    evaluationHistoryEmpty: "Oraindik ez dago ebaluazio historikorik.",
    evaluationLoadError: "Ezin izan dira ebaluazioak kargatu.",
    evaluationSaveError: "Ezin izan da ebaluazioa gorde.",
    evaluationSaved: "Ebaluazioa gorde da",
    evaluationClosedSuccess: "Ebaluazioa itxi da",
    evaluationNoPlayers: "Ez dago jokalaririk taldean.",
    evaluationNoAttendance: "Ez dago asistentzia erregistraturik",
    evaluationInternalHint: "Baimendutako langileentzako barne-edukia.",
    matchReportAction: "Akta eta errendimendua",
    matchReportTitle: "Akta profesionala eta errendimendua",
    matchReportInternalHint: "Baimendutako langileentzako barneko kirol-informazioa.",
    matchReportHeader: "Aktaren goiburua",
    matchReportVersion: "Bertsioa",
    matchReportOrigin: "Jatorria",
    matchReportAuthor: "Egilea",
    matchReportCreatedAt: "Sortuta",
    matchReportUpdatedAt: "Azken aldaketa",
    matchReportClosedAt: "Itxita",
    matchReportReopenedAt: "Berrirekita",
    matchReportCallupSummary: "Deialdiaren laburpena",
    matchReportNoCallup: "Deialdirik gabe",
    matchReportEmpty: "Oraindik ez dago partida honetarako aktarik.",
    matchReportCreateDraft: "Zirriborroa sortu",
    matchReportDraftCreated: "Aktaren zirriborroa sortu da",
    matchReportObjectiveSummary: "Partidaren laburpen objektiboa",
    matchReportCalled: "Deituak",
    matchReportStarters: "Hasierakoak",
    matchReportPlayed: "Jokatu zuten",
    matchReportMinutes: "Minutuak",
    matchReportParticipants: "Parte-hartzaileak",
    matchReportParticipationRole: "Egoera",
    matchReportInitialPosition: "Hasierako posizioa",
    matchReportStarter: "Hasierakoa",
    matchReportSubstitute: "Ordezkoa",
    matchReportDidNotPlay: "Ez du parte hartzen",
    matchReportAbsent: "Absentzia",
    matchReportLateWithdrawal: "Azken orduko baja",
    matchReportNotCalled: "Deitu gabea",
    matchReportParticipated: "Jokatu zuen",
    matchReportOwnGoals: "Norbere ateko golak",
    matchReportEntries: "Sarrerak",
    matchReportExits: "Irteerak",
    matchReportPeriods: "Aldiak",
    matchReportInitialPeriod: "Hasierako aldia",
    matchReportFinalPeriod: "Amaierako aldia",
    matchReportNoPeriod: "Aldirik gabe",
    matchReportChanges: "Aldaketak",
    matchReportAddChange: "Aldaketa gehitu",
    matchReportEntry: "Sarrera",
    matchReportExit: "Irteera",
    matchReportMinute: "Minutua",
    matchReportRemoveChange: "Aldaketa ezabatu",
    matchReportNonParticipationReason: "Parte ez hartzeko arrazoia",
    matchReportExceptionalReason: "Salbuespenezko sartzearen arrazoia",
    matchReportAvailabilityOverrideReason: "Deialdia ukatu ondoren parte hartzeko arrazoia",
    matchReportMinutesOverrideReason: "Iraupena gainditzeko administrazio-arrazoia",
    matchReportConfirmException: "Salbuespen hau berrikusi dela berresten dut",
    matchReportSubstitutions: "Ordezkapenak",
    matchReportAddSubstitution: "Ordezkapena gehitu",
    matchReportNoSubstitutions: "Ez dago ordezkapenik erregistratuta.",
    matchReportIncomingPlayer: "Sartzen den jokalaria",
    matchReportOutgoingPlayer: "Irteten den jokalaria",
    matchReportObjectiveNote: "Ohar objektiboa",
    matchReportRemoveSubstitution: "Ordezkapena ezabatu",
    matchReportGoalEvents: "Taldearen golak",
    matchReportAddGoal: "Gola gehitu",
    matchReportNoGoals: "Ez dago golik erregistratuta.",
    matchReportGoalType: "Gol mota",
    matchReportGoalPlayer: "Jokalariaren gola",
    matchReportOpponentOwnGoal: "Aurkariaren autogola",
    matchReportUnidentifiedGoal: "Egilerik gabeko gola",
    matchReportScorer: "Golegilea",
    matchReportRemoveGoal: "Gola ezabatu",
    matchReportScoreDiscrepancyReason: "Markagailuarekiko aldearen administrazio-justifikazioa",
    matchReportUnsavedChanges: "Gorde gabeko aldaketak daude.",
    matchReportDiscardChanges: "Gorde gabeko aldaketak daude. Baztertu nahi dituzu?",
    matchReportExportPdf: "Akta PDFan esportatu",
    matchReportExportError: "Ezin izan da akta esportatu.",
    matchReportIncidents: "Kirol-intzidentziak",
    matchReportInternalNotes: "Barne-oharrak",
    matchReportGeneralNotes: "Aktaren ohar orokorrak",
    matchReportValidation: "Baliozkotzeak eta abisuak",
    matchReportValid: "Aktak ixteko arauak betetzen ditu.",
    matchReportValidate: "Akta baliozkotu",
    matchReportSaveDraft: "Zirriborroa gorde",
    matchReportSaved: "Zirriborroa gorde da",
    matchReportClose: "Akta itxi",
    matchReportCloseConfirm: "Akta itxi? Ohiko ediziorako blokeatuta geratuko da.",
    matchReportConfirmWarnings: "Aktak abisuak ditu. Berrikusi dituzula berresten duzu?",
    matchReportClosedSuccess: "Akta itxi da",
    matchReportReopen: "Akta berrireki",
    matchReportReopenReason: "Berrirekitzeko nahitaezko arrazoia",
    matchReportReopenedSuccess: "Akta berrireki eta auditatu da",
    matchReportHistory: "Aldaketen historia",
    matchReportHistoryEmpty: "Oraindik ez dago aldaketarik erregistratuta.",
    matchReportNoPlayers: "Ez dago taldean jokalari hautagarririk.",
    matchReportLoadError: "Ezin izan da akta kargatu.",
    matchReportSaveError: "Ezin izan da zirriborroa gorde.",
    matchReportValidationError: "Ezin izan da akta baliozkotu.",
    matchReportCloseError: "Ezin izan da akta itxi.",
    matchReportReopenError: "Ezin izan da akta berrireki.",
    present_short: "Bertaratuak",
    manageAttendance: "Asistentzia kudeatu",
    attendanceRate: "Asistentzia",
    attendanceAlertThreshold: "Alertatzeko absentziak",
    attendanceAlerts: "behin eta berriz huts egiteagatik alertak",
    attendanceReason: "Arrazoia (aukerakoa)",
    attendanceLoadError: "Ezin izan da asistentzia kargatu",
    attendanceExportError: "Ezin izan da asistentzia esportatu",
    exerciseLibrary: "Ariketen liburutegia",
    preparedTrainingLibrary: "Entrenamenduen liburutegia",
    preparedTrainingLibraryDescription: "Aukeratu prestatutako zeregin bat eta erabili saio bat programatzean.",
    refreshTrainingLibrary: "Katalogoa eguneratu",
    trainingBlock: "Lan-blokea",
    trainingSubblock: "Azpiblokea",
    allTrainingBlocks: "Bloke guztiak",
    allTrainingSubblocks: "Azpibloke guztiak",
    preparedTrainingCount: "Eskuragarri dauden entrenamenduak",
    catalogExpected: "Indizean espero direnak",
    noPreparedTrainings: "Ez dago iragazkiekin bat datorren prestatutako entrenamendurik.",
    trainingLibraryLoadError: "Ezin izan da entrenamenduen liburutegia kargatu",
    trainingLibrarySyncError: "Ezin izan da entrenamenduen liburutegia eguneratu",
    viewPdf: "PDFa ikusi",
    usePreparedTraining: "Entrenamenduan erabili",
    choosePreparedTraining: "Liburutegitik aukeratu",
    noPreparedTrainingSelected: "Ez da prestatutako entrenamendurik aukeratu",
    allTeams: "Talde guztiak",
    duplicate: "Bikoiztu",
    duration: "Iraupena",
    objective: "Helburua",
    exerciseLibraryDescription: "Sortu, berrerabili eta ebaluatu ariketak baimendutako esparruan.",
    allObjectives: "Helburu guztiak",
    allAuthors: "Egile guztiak",
    exerciseAuthor: "Egilea",
    sortBy: "Ordenatu",
    sortNameAsc: "Izena A–Z",
    sortNameDesc: "Izena Z–A",
    sortDurationAsc: "Iraupen txikienetik handienera",
    sortDurationDesc: "Iraupen handienetik txikienera",
    exerciseImageUrl: "Irudia edo eskema (aukerako URLa)",
    viewDetails: "Xehetasuna ikusi",
    noDescription: "Deskribapenik gabe",
    exerciseFormDescription: "Definitu ariketa berrerabilgarria eta haren ikusgaitasun-esparrua.",
    exercisePickerDescription: "Bilatu eta hautatu saio honetarako ariketa bat edo gehiago.",
    templateFormDescription: "Gorde uneko plangintzaren kopia independente bat.",
    trainingFormDescription: "Planifikatu saioa eta erregistratu ondoren asistentzia eta egindako lana.",
    trainingSessions: "Saioak",
    createExercise: "Ariketa sortu",
    editExercise: "Ariketa editatu",
    exerciseSaved: "Ariketa gorde da",
    exerciseDuplicated: "Ariketa bikoiztu da",
    exerciseLibraryLoadError: "Ezin izan da ariketen liburutegia kargatu",
    noExercises: "Ez dago iragazkiekin bat datorren ariketarik.",
    exerciseCount: "Ariketak",
    plannedUses: "Planifikatutako erabilerak",
    allCategories: "Kategoria guztiak",
    archived: "Artxibatuta",
    archive: "Artxibatu",
    restore: "Berrezarri",
    confirmArchiveExercise: "Ariketa hau artxibatu? Entrenamendu historikoetan ikusgai jarraituko du.",
    confirmRestoreExercise: "Ariketa hau berrezarri?",
    recommendedDuration: "Gomendatutako iraupena (min)",
    exerciseInstructions: "Urratsez urratseko jarraibideak",
    materials: "Beharrezko materiala",
    safetyNotes: "Segurtasun-oharrak",
    intensity: "Intentsitatea",
    recommendedSpace: "Gomendatutako espazioa",
    minPlayers: "Gutxieneko jokalariak",
    maxPlayers: "Gehieneko jokalariak",
    exerciseMaxPlayers: "Gehieneko jokalariak",
    exerciseRating: "Ariketaren balorazioa",
    visibility: "Ikusgaitasuna",
    authorizedTeams: "Baimendutako taldeak",
    intensity_low: "Baxua", intensity_medium: "Ertaina", intensity_high: "Altua",
    exerciseVisibility_private: "Sortzailearen pribatua",
    exerciseVisibility_teams: "Baimendutako taldeak",
    exerciseVisibility_club: "Klub osoa",
    exerciseCategory_warmup: "Beroketa",
    exerciseCategory_technique: "Teknika",
    exerciseCategory_tactics: "Taktika",
    exerciseCategory_fitness: "Prestaketa fisikoa",
    exerciseCategory_goalkeepers: "Atezainak",
    exerciseCategory_finishing: "Amaiera",
    exerciseCategory_possession: "Jabetza",
    exerciseCategory_small_sided_game: "Partida murriztua",
    exerciseCategory_set_pieces: "Estrategia",
    exerciseCategory_cooldown: "Lasaitzera itzultzea",
    exerciseCategory_other: "Beste bat",
    plannedExercises: "Planifikatutako ariketak",
    plannedExercisesHelp: "Ordenatu saioa eta osatu ebaluazioa entrenamenduaren ondoren.",
    addExercise: "Ariketa gehitu",
    addSelected: "Hautatutakoak gehitu",
    availableExercises: "Ariketa erabilgarriak",
    noPlannedExercises: "Oraindik ez dago ariketa planifikaturik.",
    plannedDuration: "Aurreikusitako iraupena (min)",
    actualDuration: "Benetako iraupena (min)",
    performed: "Eginda",
    rating: "Balorazioa",
    exerciseRating_very_good: "Oso ondo",
    exerciseRating_good: "Ondo",
    exerciseRating_needs_improvement: "Hobetzekoa",
    exerciseRating_poor: "Gaizki",
    exerciseObservation: "Ohar espezifikoa",
    notCompletedReason: "Ez egiteko arrazoia",
    notCompletedReasonRequired: "Adierazi egin ez diren ariketen arrazoia.",
    markAllPerformed: "Guztiak eginda markatu",
    moveUp: "Gora",
    moveDown: "Behera",
    remove: "Kendu",
    saveAsTemplate: "Txantiloi gisa gorde",
    templateSaved: "Txantiloia gorde da",
    loadTemplate: "Saio-txantiloia kargatu",
    copyPreviousTraining: "Beste entrenamendu batetik kopiatu",
    confirmApplyTemplate: "Uneko plangintza txantiloi honekin ordezkatu?",
    confirmCopyExercises: "Entrenamendu honetako ariketak kopiatu?",
    historicalExerciseRecord: "Erregistro historikoa",
    duplicateTrainingDate: "Entrenamendu berriaren data (UUUU-HH-EE)",
    trainingDuplicated: "Saioa bikoiztu da",
    calledMatches: "Deituta",
    playedMatches: "Jokatuta",
    minutes: "Minutuak",
    goals: "Golak",
    assists: "Asistentziak",
    yellowCards: "Txartel horiak",
    redCards: "Txartel gorriak",
    cleanSheets: "Ate hutsak",
    rating: "Balorazioa (1-10)",
    sportNotes: "Kirol oharrak",
    recipientType: "Hartzailea",
    byTeam: "Taldeka",
    byCategory: "Kategoriaka",
    individual: "Banakakoa",
    channel: "Kanala",
    subject: "Gaia",
    message: "Mezua",
    sent: "Bidalita",
    sendDate: "Bidaltze data",
    markSent: "Bidalitzat markatu",
    history: "Mezuen historia",
    playersList: "Jokalarien zerrenda",
    familyPhones: "Familien telefonoak",
    familyEmails: "Familien emailak",
    pendingPaymentsReport: "Ordainketak zain",
    pendingAuthsReport: "Baimenak zain",
    statsReport: "Jokalari estatistikak",
    exportCSV: "Esportatu Excel/CSV",
    exportPDF: "Inprimatu / PDF",
    selectReport: "Hautatu txosten bat",
    rows: "errenkada",
    activePlayers: "Jokalari aktiboak",
    newInscriptions: "Izen-emate berriak",
    pendingInscriptions: "Izen-emate zain",
    pendingDocs: "Dokumentazioa zain",
    pendingPayments: "Ordainketak zain",
    upcomingMatches: "Hurrengo partidak",
    importantAlerts: "Abisu garrantzitsuak",
    quickActions: "Sarbide azkarrak",
    newPlayer: "Jokalari berria",
    newMatch: "Partida berria",
    newCallup: "Deialdi berria",
    newAuthorization: "Baimen berria",
    newPayment: "Ordainketa berria",
    newTeam: "Talde berria",
    noAlerts: "Abisurik ez. Dena ondo.",
    noUpcoming: "Ez dago hurrengo partidarik.",
    totalPlayers: "jokalari guztira",
    pendingAmount: "zenbateko zain",
    dashboardFilters: "Panelaren iragazkiak",
    nextActivity: "Hurrengo jarduera",
    noNextActivity: "Ez dago etorkizuneko jarduerarik programatuta.",
    weeklySummary: "Asteko laburpena",
    pendingCallups: "Erantzun gabeko deialdiak",
    pendingCommunications: "Komunikazioak zain",
    latestCommunications: "Azken komunikazioak",
    noCommunications: "Ez dago komunikaziorik.",
    availablePlayers: "Jokalari erabilgarriak",
    absentPlayers: "Jokalari ez daudenak",
    associatedChildren: "Lotutako seme-alabak",
    callupStatus: "Deialdiaren egoera",
    incidents: "Gorabeherak",
    noIncidents: "Ez dago gorabeherarik.",
    search: "Bilatu...",
    add: "Gehitu",
    save: "Gorde",
    cancel: "Utzi",
    edit: "Editatu",
    delete: "Ezabatu",
    view: "Ikusi",
    print: "Inprimatu / PDF",
    actions: "Ekintzak",
    name: "Izena",
    surname: "Abizenak",
    status: "Egoera",
    category: "Kategoria",
    team: "Taldea",
    all: "Guztiak",
    none: "Bat ere ez",
    yes: "Bai",
    no: "Ez",
    noData: "Oraindik ez dago erregistrorik.",
    confirmDelete: "Ziur erregistro hau ezabatu nahi duzula?",
    saved: "Ondo gorde da",
    deleted: "Ondo ezabatu da",
    tabPersonal: "Pertsonala",
    tabSport: "Kirola",
    tabFamily: "Familia",
    tabHealth: "Osasuna",
    tabKit: "Ekipamendua",
    tabDocs: "Dokumentazioa",
    birthdate: "Jaiotze-data",
    school: "Ikastetxea",
    enrollDate: "Izen-emate data",
    formEmail: "Inprimakiko emaila",
    address: "Helbidea",
    parent1: "Aita / 1. gurasoa",
    parent2: "Ama / 2. gurasoa",
    phone: "Telefonoa",
    email: "Emaila",
    photo: "Jokalariaren argazkia",
    number: "Dortsala",
    position: "Ohiko posizioa",
    license: "Lizentzia zk.",
    altaDate: "Alta data",
    bajaDate: "Baja data",
    newPlayerFlag: "Sarrera berria",
    secondSibling: "Bigarren anai-arreba",
    discount: "Aplikatutako deskontua (€)",
    notes: "Barne oharrak",
    allergies: "Alergiak",
    diseases: "Gaixotasun garrantzitsuak",
    medication: "Medikazioa",
    medicalInsurance: "Mediku-asegurua",
    emergencyContact: "Larrialdi-kontaktua",
    emergencyPhone: "Larrialdi-telefonoa",
    medicalNotes: "Mediku-oharrak",
    shirtSize: "Elastikoaren neurria",
    pantsSize: "Galtzen neurria",
    tracksuitSize: "Txandalaren neurria",
    socksSize: "Galtzerdien neurria",
    shoeSize: "Oinetakoen neurria",
    kitDelivered: "Ekipamendua emanda",
    deliveryDate: "Entrega data",
    kitNotes: "Materialaren oharrak",
    docStatus: "Dokumentu-egoera",
    reviewDate: "Berrikuspen data",
    season: "Denboraldia",
    teamsIntro: "Antolatu plantillak denboraldika eta atzitu jokalariak historiak nahastu gabe.",
    teamsSummary: "Taldeen laburpena",
    seasonFoldersTitle: "Denboraldiak",
    seasonFoldersDescription: "Hautatu denboraldi bat bere taldeak eta plantillak bakarrik ikusteko.",
    createNextSeason: "Sortu hurrengo denboraldia",
    createNextSeasonTitle: "Sortu hurrengo denboraldia",
    createNextSeasonDescription: "Sortu talde berriak egitura berarekin eta prestatu plantillak aurreko denboraldia aldatu gabe.",
    sourceSeason: "Jatorrizko denboraldia",
    targetSeason: "Denboraldi berria",
    seasonCopyWarning: "Aurreko denboraldiko taldeak eta jokalariak abiapuntu gisa gordeko dira. Ondoren alta, baja eta talde aldaketak egin ahal izango dituzu denboraldi berrian; aurreko historia bere horretan mantenduko da.",
    seasonCopyConfirm: "Sortu denboraldi berria bere talde eta plantillak kopiatuz?",
    seasonCopyRequired: "Aukeratu jatorrizko denboraldia eta idatzi denboraldi berria.",
    seasonCopyDifferent: "Denboraldi berriak jatorrizko denboralditik desberdina izan behar du.",
    seasonAlreadyExists: "Helmugako denboraldia dagoeneko badago.",
    seasonCopySuccess: "Denboraldia behar bezala sortu da:",
    seasonCopyError: "Ezin izan da denboraldia sortu.",
    copyingSeason: "Denboraldia sortzen…",
    teamsCount: "talde",
    selectedSeason: "Hautatutako denboraldia",
    viewTeams: "Ikusi taldeak",
    viewPlayers: "Ikusi jokalariak",
    unassignedSeason: "Denboraldirik gabe",
    seasonNoTeams: "Ez dago denboraldi honetara esleitutako talderik.",
    noFilteredTeams: "Ez dago hautatutako iragazkiekin bat datorren talderik.",
    searchTeamsPlaceholder: "Bilatu izenaren, kategoriaren edo entrenatzailearen arabera",
    allCategories: "Kategoria guztiak",
    clearTeamFilters: "Garbitu iragazkiak",
    coach: "Entrenatzailea",
    secondCoach: "Bigarren entrenatzailea",
    delegate: "Ordezkaria",
    trainingDays: "Entrenamendu egunak",
    schedule: "Ordutegia",
    field: "Zelaia",
    maxPlayers: "Jokalari muga",
    roster: "Plantilla",
    playersCount: "jokalari",
    mainContact: "Kontaktu nagusia",
    commPreference: "Komunikazio lehentasuna",
    children: "Izena emandako seme-alabak",
    matchday: "Jardunaldia",
    date: "Data",
    time: "Ordua",
    ownTeam: "Talde propioa",
    rival: "Aurkaria",
    homeAway: "Etxean / Kanpoan",
    home: "Etxean",
    away: "Kanpoan",
    fieldAddress: "Zelaiaren helbidea",
    matchType: "Partida mota",
    result: "Emaitza",
    ownResult: "Emaitza propioa",
    rivalResult: "Aurkariaren emaitza",
    match: "Partida",
    calledPlayers: "Deitutako jokalariak",
    notCalledPlayers: "Deitu gabeko jokalariak",
    meetTime: "Elkartzeko ordua",
    meetPlace: "Elkartzeko lekua",
    material: "Beharrezko materiala",
    messageFamilies: "Familientzako mezua",
    selectPlayers: "Hautatu jokalariak",
    pending: "zain",
    confirmed: "baieztatuta",
    declined: "ukatuta",
    searchPlayer: "Bilatu jokalaria",
    filterByStatus: "Iragazi egoeraren arabera",
    allStatuses: "Egoera guztiak",
    responseDeadline: "Erantzuteko epea",
    deadlineExpired: "Epea amaituta",
    confirmAttendance: "Baieztatu",
    declineAttendance: "Ukatu",
    confirmAllPending: "Baieztatu zain daudenak",
    declineAllPending: "Ukatu zain daudenak",
    confirmAllPendingQuestion: "Deialdi honetako zain dauden jokalari guztiak baieztatu nahi dituzu?",
    declineAllPendingQuestion: "Deialdi honetako zain dauden jokalari guztiak ukatu nahi dituzu?",
    confirmSave: "Erantzun hau gorde nahi duzu?",
    declineReasonOptional: "Uko egiteko arrazoia (aukerakoa)",
    responseSaved: "Erantzuna gordeta",
    bulkResponseSaved: "{count} erantzun eguneratu dira",
    bulkResponseError: "Ezin izan dira zain dauden erantzunak eguneratu.",
    reason: "Arrazoia",
    selectMatch: "Hautatu partida bat",
    editCallup: "Deialdia editatu",
    teamPlayers: "Taldeko jokalariak",
    reinforcements: "Beste taldeetako errefortzuak",
    downloadPdf: "Deskargatu PDF elebiduna",
    allowPlayerResponse: "Baimendu jokalariak zuzenean erantzutea",
    paymentPlayer: "Lotutako jokalaria",
    paymentPlayerColumn: "Jokalaria",
    concept: "Kontzeptua",
    baseAmount: "Oinarrizko zenbatekoa (€)",
    siblingDiscount: "Anai-arreba deskontua (€)",
    finalAmount: "Azken zenbatekoa (€)",
    accountHolder: "Kontu titularra",
    paymentMethod: "Ordainketa modua",
    iban: "Banku-kontua / IBAN",
    paymentDate: "Ordainketa data",
    authType: "Baimen mota",
    authorizedPerson: "Jasotzeko baimendua",
    authorizedDni: "Baimenduaren NAN",
    signer: "Sinatzailea (guraso/tutorea)",
    signDate: "Sinadura data",
    expiryDate: "Iraungitze data",
    clubData: "Klubaren datuak",
    clubName: "Klubaren izena",
    clubAddress: "Helbidea",
    clubEmail: "Klubaren emaila",
    clubPhone: "Klubaren telefonoa",
    currentSeason: "Uneko denboraldia",
    seasons: "Denboraldiak",
    fields: "Jokatzeko zelaiak",
    coaches: "Entrenatzaileak",
    assistantReviewTitle: "Berrikusteko",
    assistantReviewLoading: "Informazio segurua eguneratzen…",
    assistantReviewError: "Ezin izan da laguntzailearen informazioa eguneratu",
    assistantReviewEmpty: "Oraingoz dena eguneratuta dago.",
    assistantHideReview: "Ezkutatu ohar hau saio honetan",
    assistantReview_authorizations_pending: "berrikusteko baimen zain",
    assistantReview_callups_pending: "erantzuteko deialdi zain",
    assistantReview_communications_attention: "arreta behar duten komunikazio",
    assistantReview_attendance_alerts: "zure taldeetako asistentzia-alerta",
    assistantReview_payments_pending: "berrikusteko ordainketa zain",
    assistantReview_next_activity: "Hurrengo jarduera bat duzu",
    baseFee: "Oinarrizko kuota (€)",
    siblingDiscountCfg: "Anai-arreba deskontua (€)",
    categoriesByAge: "Adin-kategoriak",
    addItem: "Gehitu (Enter)",
    quickStart: "Hasi zure lehen jokalaria alta emanez",
    dataManagement: "Datuak eta datu-basea",
    exportDB: "Excel-era esportatu",
    assistantOrientation: "Aurkitzeko laguntza ematen dizut",
    assistantQuickLinks: "Sarbide azkarrak",
    assistantQuickGuide: "Gida azkarra",
    assistantOpenCurrentModule: "Ireki pantaila hau",
    assistantDailyWelcome_users: "Hemendik klubeko kontuak, rolak eta segurtasuna aurki ditzakezu.",
    assistantDailyWelcome_families: "Hemen baimendutako familia-harremanak eta lotutako fitxak aurkituko dituzu.",
    assistantDailyWelcome_players: "Hemen zure esparruko fitxen kontsulta eta kudeaketa bidera dezakezu.",
    assistantDailyWelcome_communications: "Hemen baimendutako komunikazioak aurki ditzakezu moduluan prestatu aurretik.",
    assistantDailyWelcome_authorizations: "Hemen zure rolarentzat baimendutako baimenen prozesua berrikusi dezakezu.",
    assistantDailyWelcome_payments: "Hemen baimendutako kudeaketa ekonomikoa kontsulta dezakezu laguntzailetik kobrantzarik egin gabe.",
    assistantDailyWelcome_trainings: "Hemen entrenamenduen plangintza, ariketak eta asistentzia aurki ditzakezu.",
    assistantDailyWelcome_reports: "Hemen txostenak eta haien iragazkiak aurki ditzakezu aurrebista edo esportazioa egin aurretik.",
    assistantDailyWelcome_settings: "Hemen zure rolarentzat eskuragarri dauden administrazio-ezarpenak aurki ditzakezu.",
    assistantDailyGuide_users_1: "Berrikusi kontuak eta haien egoera.", assistantDailyGuide_users_2: "Egiaztatu rola eta esparrua ezer aldatu aurretik.", assistantDailyGuide_users_3: "Egin aldaketak Erabiltzaileak moduluan baieztapenarekin.",
    assistantDailyGuide_families_1: "Bilatu familia zure esparruan.", assistantDailyGuide_families_2: "Egiaztatu dagokion fitxarekiko harremana.", assistantDailyGuide_families_3: "Eguneratu baimendutako inprimakitik soilik.",
    assistantDailyGuide_players_1: "Aurkitu baimendutako jokalari-fitxa.", assistantDailyGuide_players_2: "Berrikusi taldea, kategoria eta egoera.", assistantDailyGuide_players_3: "Erabili moduluko inprimakia aldaketetarako.",
    assistantDailyGuide_communications_1: "Ireki Komunikazioak.", assistantDailyGuide_communications_2: "Hautatu baimendutako hartzaileak soilik.", assistantDailyGuide_communications_3: "Berrikusi edukia modulutik bidali aurretik.",
    assistantDailyGuide_authorizations_1: "Ireki Baimenak.", assistantDailyGuide_authorizations_2: "Berrikusi zure rolarentzat baimendutako egoera.", assistantDailyGuide_authorizations_3: "Deskargatu edo kudeatu dokumentua bere fluxu ofizialetik.",
    assistantDailyGuide_payments_1: "Ireki Kuotak eta ordainketak.", assistantDailyGuide_payments_2: "Berrikusi baimendutako egoera ekonomikoa.", assistantDailyGuide_payments_3: "Kudeatu aldaketak modulu ofizialetik.",
    assistantDailyGuide_trainings_1: "Ireki Entrenamenduak.", assistantDailyGuide_trainings_2: "Aukeratu saioa zure esparruan.", assistantDailyGuide_trainings_3: "Planifikatu edo erregistratu asistentzia baimendutako fluxutik.",
    assistantDailyGuide_reports_1: "Ireki Txostenak.", assistantDailyGuide_reports_2: "Aplikatu behar dituzun iragazkiak.", assistantDailyGuide_reports_3: "Egin aurrebista edo esportazioa modulutik soilik.",
    assistantDailyGuide_settings_1: "Ireki Konfigurazioa.", assistantDailyGuide_settings_2: "Berrikusi behar duzun ezarpena.", assistantDailyGuide_settings_3: "Gorde aldaketak inprimaki ofizialetik soilik.",
    importDB: "Excel-etik inportatu",
    loadDemo: "Adibide datuak kargatu",
    clearAll: "Dena hustu",
    exportDBDesc: "Deskargatu datu-base osoa (jokalariak, taldeak, partidak...) Excel artxibo batean, modulu bakoitzeko orri batekin.",
    importDBDesc: "Igo Excel artxibo bat datu-basea ordezkatzeko. Erabili esportazioaren formatu bera.",
    importWarning: "Honek uneko datuak ordezkatuko ditu. Jarraitu?",
    clearWarning: "Datu GUZTIAK ezabatuko dira. Ziur?",
    demoWarning: "Honek uneko datuak adibide datuekin ordezkatuko ditu. Jarraitu?",
    importDone: "Inportazioa amaituta",
    exporting: "Esportatzen…",
    importing: "Inportatzen…",
    assistantOpen: "Laguntzailea ireki",
    assistantIdentity: "Laguntxi · Ikas‑Txikiko laguntzailea",
    assistantShort: "Laguntzailea",
    assistantTitle: "Laguntxi · Ikas‑Txikiko laguntzailea",
    assistantDescription: "Testuinguruko laguntza eta baieztapendun kudeaketa gidatua.",
    assistantWelcomeTitle: "Kaixo, Ikastxikiko maskota naiz.",
    assistantWelcomeDescription: "Hemen nago klubaren kudeaketan laguntzeko.",
    assistantPrivacyWarning: "IA laguntzailea da. Ez sartu NANik, IBANik, datu medikorik, pasahitzik edo dokumentazio pribaturik.",
    assistantCurrentContext: "Hau kontsultatzen ari zara",
    assistantAvailableModules: "Arakatu Ikas‑Txiki",
    assistantAvailableModulesHelp: "Zure rolarentzat eskuragarri dauden sarbideak. Laguntzaileak ez du baimenik gabeko modulurik erakusten.",
    assistantGeneralHelp: "Erabilera-laguntza",
    assistantGuidedManagement: "Ekintza gidatuak",
    assistantGuidedDescription: "Aldaketak aurrez prestatzen dira eta ez dira gordetzen berariaz baieztatu gabe.",
    assistantQuestionScreen: "Zer egin dezaket pantaila honetan?",
    assistantQuestionPermissions: "Zer aukera baimentzen ditu nire rolak?",
    assistantQuestionDashboard: "Nola interpretatzen da panel nagusia?",
    assistantQuestionPlayer: "Nola kudeatzen da jokalari baten fitxa?",
    assistantQuestionFamily: "Nola lotzen dira familia eta jokalaria?",
    assistantQuestionTeam: "Nola kontsultatu eta kudeatu talde baten plantilla?",
    assistantQuestionInscription: "Nola berrikusi inskripzioa edo Excel zirriborroa?",
    assistantQuestionTraining: "Nola planifikatu entrenamendua eta erregistratu asistentzia?",
    assistantQuestionMatch: "Nola prestatu partida, akta eta errendimendua?",
    assistantQuestionAttendance: "Nola erregistratzen da asistentzia?",
    assistantQuestionCallup: "Nola funtzionatzen du deialdi batek?",
    assistantQuestionPayment: "Nola berrikusi kuotak eta ordainketak zor okerrik sortu gabe?",
    assistantQuestionAuthorization: "Nola berrikusi zain dauden baimenak?",
    assistantQuestionEquipment: "Nola kudeatu neurriak, entregak eta ekipazioak?",
    assistantQuestionCommunication: "Nola prestatu komunikazioa talde egokiarentzat?",
    assistantQuestionCalendar: "Nola kontsultatu partidak, entrenamenduak eta ekitaldiak?",
    assistantQuestionReports: "Nola erabili eta esportatu txosten bat?",
    assistantQuestionStats: "Nola aplikatu iragazkiak eta interpretatu estatistikak?",
    assistantQuestionSettings: "Nola konfiguratu kluba modu seguruan?",
    assistantQuestionUsers: "Nola administratu erabiltzaileak, rolak eta segurtasuna?",
    assistantQuestionPortal: "Zer kontsulta dezake familia edo jokalari batek atarian?",
    assistantModule_dashboard: "Panel nagusia", assistantModule_players: "Jokalariak",
    assistantModule_families: "Familiak", assistantModule_teams: "Taldeak",
    assistantModule_inscriptions: "Inskripzioak", assistantModule_trainings: "Entrenamenduak",
    assistantModule_matches: "Partidak", assistantModule_callups: "Deialdiak",
    assistantModule_payments: "Kuotak eta ordainketak", assistantModule_authorizations: "Baimenak",
    assistantModule_equipment: "Ekipamendua", assistantModule_communications: "Komunikazioak",
    assistantModule_calendar: "Egutegia", assistantModule_reports: "Txostenak",
    assistantModule_stats: "Estatistikak", assistantModule_settings: "Konfigurazioa",
    assistantModule_users: "Erabiltzaileak, rolak eta segurtasuna", assistantModule_portal: "Ataria",
    assistantModule_unknown: "Pantaila hau",
    assistantGeneralChannel: "Laguntza orokorra",
    assistantInternalChannel: "Barne-kanal segurua",
    assistantProcessedInternally: "Pribatutasunagatik, kontsulta hau Ikas‑Txikiren barruan mantendu da.",
    assistantOpenModule: "Modulua ireki",
    assistantQuestion: "Laguntzailearentzako galdera",
    assistantPlaceholder: "Galdetu pantaila hau nola erabili…",
    assistantSend: "Galdera bidali",
    assistantAction: "Eragiketa",
    assistantSelectAction: "Hautatu eragiketa",
    assistantTargetId: "Erregistroaren identifikatzailea",
    assistantPreparePreview: "Aurrebista prestatu",
    assistantExactPreview: "Aldaketaren aurrebista zehatza",
    assistantPossibleDuplicates: "Balizko bat-etortzeak aurkitu dira. Berrikusi baieztatu aurretik.",
    assistantCancel: "Utzi",
    assistantConfirm: "Aldaketa baieztatu",
    assistantNoActions: "Zure rolak ez du eragiketa gidaturik lehen bertsio honetan.",
    assistantLoadError: "Ezin izan da laguntzailea kargatu.",
    assistantError: "Ezin izan da erantzun. Berriro saia zaitezke.",
    assistantProposalError: "Ezin izan da aldaketa prestatu.",
    assistantConfirmError: "Ezin izan da aldaketa baieztatu.",
    assistantChangeSaved: "Aldaketa baliozkotu, gorde eta auditorian erregistratu da.",
    assistantAction_player_create: "Jokalaria sortu",
    assistantAction_player_update: "Jokalaria eguneratu",
    assistantAction_family_create: "Familia sortu",
    assistantAction_family_update: "Familia eguneratu",
    assistantAction_player_link_family: "Jokalaria eta familia lotu",
    assistantAction_player_assign_team: "Jokalaria taldeari esleitu",
    assistantAction_inscription_create: "Inskripzioa erregistratu",
    assistantAction_attendance_update: "Asistentzia erregistratu",
    assistantAction_callup_prepare: "Deialdia prestatu",
    assistantAction_equipment_update: "Ekipamendua eguneratu",
    assistantField_nombre: "Izena", assistantField_apellidos: "Abizenak",
    assistantField_fecha_nacimiento: "Jaioteguna", assistantField_centro_escolar: "Ikastetxea",
    assistantField_categoria: "Kategoria", assistantField_equipo_id: "Taldea",
    assistantField_dorsal: "Dortsala", assistantField_posicion: "Posizioa",
    assistantField_estado: "Egoera", assistantField_familia_id: "Familia",
    assistantField_progenitor1_nombre: "1. tutorea", assistantField_progenitor1_telefono: "1. tutorearen telefonoa",
    assistantField_progenitor1_email: "1. tutorearen posta", assistantField_progenitor2_nombre: "2. tutorea",
    assistantField_progenitor2_telefono: "2. tutorearen telefonoa", assistantField_progenitor2_email: "2. tutorearen posta",
    assistantField_domicilio: "Helbidea", assistantField_contacto_principal: "Kontaktu nagusia",
    assistantField_preferencia_comunicacion: "Komunikazio-lehentasuna", assistantField_observaciones: "Oharrak",
    assistantField_tipo: "Mota", assistantField_nueva_incorporacion: "Sarrera berria",
    assistantField_temporada: "Denboraldia", assistantField_modalidad: "Modalitatea",
    assistantField_equipamiento_items: "Ekipazioak (komaz bereizita)",
    assistantField_training_id: "Entrenamendua", assistantField_player_id: "Jokalaria",
    assistantField_motivo: "Arrazoia", assistantField_match_id: "Partida",
    assistantField_convocados: "Deitutakoak (JSON)", assistantField_hora_quedada: "Elkartzeko ordua",
    assistantField_lugar_quedada: "Elkartzeko lekua", assistantField_material: "Materiala",
    assistantField_mensaje_familias: "Jarraibideak", assistantField_response_deadline: "Erantzuteko epea",
    assistantField_player_self_response_allowed: "Jokalariaren erantzun zuzena",
    assistantField_talla_camiseta: "Kamiseta neurria", assistantField_talla_pantalon: "Praka neurria",
    assistantField_talla_chandal: "Txandal neurria", assistantField_talla_medias: "Galtzerdi neurria",
    assistantField_talla_calzado: "Oinetako neurria", assistantField_equipacion_entregada: "Ekipazioa entregatuta",
    assistantField_fecha_entrega_equipacion: "Entrega-data", assistantField_observaciones_material: "Materialaren oharrak",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "es");
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => translations[lang][key] || translations.es[key] || key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);

// Shared option labels (bilingual)
export const STATUS_LABELS = {
  es: {
    activo: "Activo", baja: "Baja", lesionado: "Lesionado",
    pendiente_documentacion: "Pend. documentación", en_prueba: "En prueba",
    completo: "Completo", pendiente: "Pendiente", incompleto: "Incompleto",
    programado: "Programado", jugado: "Jugado", aplazado: "Aplazado",
    suspendido: "Suspendido", cancelado: "Cancelado",
    pagado: "Pagado", parcial: "Parcial", devuelto: "Devuelto",
    firmada: "Firmada", caducada: "Caducada", confirmado: "Confirmado",
    no_puede: "No puede asistir", cerrado: "Cerrado",
    recibida: "Recibida", revisada: "Revisada", aceptada: "Aceptada", rechazada: "Rechazada",
    presente: "Presente", justificada: "Justificada", injustificada: "Sin justificar", lesion: "Lesión",
    draft: "Borrador", completed: "Completada", closed: "Cerrada", reopened: "Reabierta",
    starter: "Titular", substitute: "Suplente", did_not_play: "No participa", absent: "Ausencia",
    late_withdrawal: "Baja de última hora", not_called: "No convocado",
    pending: "Pendiente", confirmed: "Confirmado", declined: "Rechazado",
  },
  eu: {
    activo: "Aktibo", baja: "Baja", lesionado: "Lesionatua",
    pendiente_documentacion: "Dok. zain", en_prueba: "Probetan",
    completo: "Osatua", pendiente: "Zain", incompleto: "Osatu gabe",
    programado: "Programatua", jugado: "Jokatua", aplazado: "Atzeratua",
    suspendido: "Bertan behera", cancelado: "Ezeztatua",
    pagado: "Ordainduta", parcial: "Partziala", devuelto: "Itzulia",
    firmada: "Sinatua", caducada: "Iraungia", confirmado: "Baieztatua",
    no_puede: "Ezin du", cerrado: "Itxia",
    recibida: "Jasota", revisada: "Berrikusita", aceptada: "Onartua", rechazada: "Ezetsia",
    presente: "Bertan", justificada: "Justifikatua", injustificada: "Justifikatu gabe", lesion: "Lesioa",
    draft: "Zirriborroa", completed: "Osatua", closed: "Itxita", reopened: "Berrirekia",
    starter: "Hasierakoa", substitute: "Ordezkoa", did_not_play: "Ez du parte hartzen", absent: "Absentzia",
    late_withdrawal: "Azken orduko baja", not_called: "Deitu gabe",
    pending: "Zain", confirmed: "Baieztatuta", declined: "Ukatuta",
  },
};
